window.slate = window.slate || {};
window.theme = window.theme || {};  

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
  
  /* CF-60 - initally hidden elements should have focus removed
   *	use class `.hidden-focus` where tabindex=0 - should be -1 if hidden
   */
  toggleHiddenFocus: function(e, state) {
  	console.info('!~~ toggle tabindex for ' + e);
    switch(state) {
      case 'show':
        $(e).find('.hidden-focus, .hidden-element').attr('tabindex',0);
        break;
      case 'hide':
      default:
        $(e).find('.hidden-focus, .hidden-element').attr('tabindex',-1);
        break;
    }
  },
  
  toggleARIAHidden: function(e, state) {
  	console.info('!~~ toggle aria-hidden for ' + e);
    switch(state) {
      case 'show':
        $(e).find('.hidden-focus, .hidden-element').removeAttr('aria-hidden').attr('aria-hidden',false);
        break;
      case 'hide':
      default:
        $(e).find('.hidden-focus, .hidden-element').removeAttr('aria-hidden').attr('aria-hidden',true);
        break;
    }
  }
  
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function() {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {
    var uri = uri != undefined ? uri : window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
    var uri = uri != undefined ? uri : window.location.href,
        rtn = uri.split("?")[0],
        param,
        params_arr = [],
        queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === parameterKeyToRemove) {
                params_arr.splice(i, 1);
            }
        }
         if (params_arr.length > 0) { 
          rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
  },  

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function() {
    return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function() {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    };

    for(t in transitions){
      if( el.style[t] !== undefined ){
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function() {
    var ua = navigator.userAgent,
        d = document.documentElement,
        classes = d.className;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
      classes += ' ua-ios';

      // Add class for version of iOS
      var matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if ( matches ) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if ( /Twitter/.test(ua) ) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if ( /CriOS/.test(ua) ) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if ( /Android/.test(ua) ) {
      var matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g,'_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if ( /webOS|hpwOS/.test(ua) ) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if ( /SamsungBrowser/.test(ua) ) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   * Reference - https://stackoverflow.com/a/7616484
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function(string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr   = string.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();
  },
  
  /**
   * CHECK IF USER IS ON GIVEN SFMC LIST
   * 
   * see: CF-14
   *

   @params:
   	list {string}: the SFMC list to check
    email {string}: the user's email

   @return {bool}

   */
  subscribedToList: function(list, email) {
    $.ajax({
      async: true,
      crossDomain: true,
      url: "", // TODO: endpoint "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      data: {
        // TODO data
        "data": "data",
        "list": list
      }
    })
    .done(function(response) {
      if(response.success) {
        // successful response
        // are they on list
        if (onList) {
          return true;
        } else {
          return false;
        }
      }
      else {
        // did not recieve proper response, assume not on list
        return false;
      }
    })
    .fail(function(jqXHR, textStatus) {        
      var errors = [];
      if(jqXHR.responseJSON.hasOwnProperty('errors')) {
        errors = jqXHR.responseJSON.errors;
      }
      // ajax errors, assume not on list, log errors
      if(errors instanceof Array && errors.length) {
        for (var i = errors.length - 1; i >= 0; i--) {
          console.warn('-- subscribedToList() - error: "' + errors[i] + '"');
        }
      }
      return false;
    });
    //     return false;
  },

  /**
   * check which page or section we are on

   adds the utility to check if we are on a certain page or section. created for CF-14 to determine when not to show subscription modal

   @return {bool}

   */
  isOnPage: function(pageHandle) {
    var _regex = new RegExp(''+pageHandle+'','i');

    return _regex.test(location.href);
  }
  
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  fixTables: function() {
    $('.rte').find('table').each(function() {
      $(this).addClass('table');
      $(this).wrap('<div class="table-responsive"></div>');
    });
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Collection Filters
 * ------------------------------------------------------------------------------
 *
 * @namespace - collectionFilters
 */

slate.collectionFilters = (function(){

  var $body = $(document.body);
  var selectors = {
    filterSelect: '[data-filters-type][data-filters-type-select]',
    filterRadio: '[data-filters-type][data-filters-type-radio]',
    filtersClear: '[data-filters-clear]',
    mobileFilters: '[data-mobile-filters]',
    mobileFiltersToggle: '[data-mobile-filters-toggle]',
    mobileFiltersApply: '[data-mobile-filters-apply]'
  };

  var classes = {
    open: 'is-open',
    bodyOpen: 'mobile-menu-open',
    menuActiveLink: 'mobile-menu__primary-link-active'
  };

  /**
   * CollectionFilters constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionFilters(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionFilters';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    $(selectors.filterSelect, this.$container).on('change', this.onDesktopFilterSelectChange.bind(this));
    $(selectors.filtersClear, this.$container).on('click', this.onFilterClearClick.bind(this));

    $(selectors.mobileFiltersToggle, this.$container).on('click', this.onMobileFiltersToggleClick.bind(this));
    $(selectors.mobileFiltersApply, this.$container).on('click', this.onMobileFiltersApplyClick.bind(this));

    this._sortFilters();
  }

  CollectionFilters.prototype = $.extend({}, CollectionFilters.prototype, {

    /**
     * Returns a url for the current collection with selected filters
     *
     * @return {string} - url
     */
    _getCollectionUrlWithDesktopFilters: function() {
      var collectionUrl = this.collectionData.url;
      var tags = [];

      $(selectors.filterSelect, this.container).find('option:selected').each(function(){
        // Make sure we don't push empty strings
        if($(this).val()){
          tags.push( $(this).val() );
        }
      });

      tags = tags.map(function (str) {
        return str
          .toLowerCase()
          .replace(/[^\w\u00C0-\u024f]+/g, "-")
          .replace(/^-+|-+$/g, "");
      });

      return tags.length ? collectionUrl + '/' + tags.join('+') : collectionUrl;
    },

    _getCollectionUrlWithFilters: function() {
      var collectionUrl = this.collectionData.url;
      var tags = [];

      $(selectors.filterRadio, this.container).filter(':checked').each(function(){
        // Make sure we don't push empty strings
        if($(this).val()){
          tags.push( $(this).val() );
        }
      });

      tags = tags.map(function (str) {
        return str
          .toLowerCase()
          .replace(/[^\w\u00C0-\u024f]+/g, "-")
          .replace(/^-+|-+$/g, "");
      });

      return tags.length ? collectionUrl + '/' + tags.join('+') : collectionUrl;
    },

    /**
     * Filtering has nothing to do with the query string so make sure we don't mess with it.
     *
     * @return (string) - Empty string or query string with '?' prefix
     */
    _getQueryString: function() {
      var queryString = location.search && location.search.substr(1) || '';

      // Add the '?' prefix if there is an actual query
      if(queryString.length){
        queryString = '?' + queryString;
      }

      return queryString;
    },

    _sortingFunctions: {

      /**
       * Sorts sizes based on a predefined order
       *
       * @param (string) a
       * @param (string) b
       * @return (int)
       */
      size: function(a, b) {
        console.warn('[collectionFilters] - _sortingFunctions.size - This method hasn\'t been implemented yet.');
        // Implement this so sizes show up how we expect them to? small, med, large..
      }
    },

    /**
     * Sorts the filter options inside each select tag if there is an applicable sort function available
     */
    _sortFilters: function() {
      var self = this;

      $(selectors.filterSelect, this.$container).each(function(){
        var $select = $(this);
        var $toSort = $select.find('option');
        var sortingFunction = self._sortingFunctions[ $select.data('filters-type') ];

        if(sortingFunction){
          $toSort.sort(function(a, b) {
            return sortingFunction($(a).val(), $(b).val());
          });
        }
      });
    },

    /**
     * Redirects the browser to the collection page with any filters applied
     */
    applyFilters: function() {
      window.location.href = this._getCollectionUrlWithDesktopFilters() + this._getQueryString();
    },

    openMobileFilters: function() {
      $(document.body).addClass(classes.bodyOpen);
      $(selectors.mobileFilters, this.$container).addClass(classes.open);
    },

    closeMobileFilters: function() {
      $(document.body).removeClass(classes.bodyOpen);
      $(selectors.mobileFilters, this.$container).removeClass(classes.open);
    },

    /**
     * Redirects the browser to the collection page without any filters applied
     */
    clear: function() {
      window.location.href = this.collectionData.url + this._getQueryString();
    },

    /**
     * Opens filters modal when mobile filters selector is clicked
     */
    // TODO: need to do a check if mobile menu is already open
    onMobileFiltersToggleClick: function(e) {
      e.preventDefault();
      this.openMobileFilters();
    },

    /**
     * When `apply` button in mobile filters modal is clicked
     */
    onMobileFiltersApplyClick: function(e) {
      e.preventDefault();
      this.closeMobileFilters();
      // console.log(this._getCollectionUrlWithFilters());
      // TODO: prevent refresh if nothing changes
      window.location.href = this._getCollectionUrlWithFilters() + this._getQueryString();
    },

    onMobileFilterRadioChange: function(e) {
      e.preventDefault();
      // this._getCollectionUrlWithFilters();
      // console.log(this._getCollectionUrlWithFilters());
    },

    /**
     * Looks for change event on filters' <select> (on desktop)
     */
    onDesktopFilterSelectChange: function(e) {
      e.preventDefault();
      this.applyFilters();
    },

    onFilterClearClick: function(e) {
      e.preventDefault();
      this.clear();
    }
  });

  return CollectionFilters;
})();

/**
 * Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - collectionSort
 */

slate.collectionSort = (function(){

  var $body = $(document.body);
  var selectors = {
    sortSelect: '[data-sort-select]'
  };

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.sortSelect, this.applySort.bind(this));
  }

  CollectionSort.prototype = $.extend({}, CollectionSort.prototype, {
    applySort: function() {
      var sortBy = $(selectors.sortSelect, this.container).find('option:selected').val();
      var queryParams = slate.utils.getQueryParams();

      if(sortBy !== this.collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }
      else {
        delete queryParams.sort_by;
      }

      location.search = $.param(queryParams);
    }
  });

  return CollectionSort;
})();

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * This is a bare-bones but completely usable implementation of an AJAX enabled cart
 *
 * Usage: slate.AjaxCart.init(options);
 *
 * See the following list of stubbed / incomplete methods that need to be filled in
 *
 *   - AjaxCart.onOpenClick
 *   - AjaxCart.onCloseClick
 *   - AjaxCart.open
 *   - AjaxCart.close
 *   - AjaxCart.onItemAddFail
 *   - AjaxCart.buildCart
 *
 */

(function($, Handlebars, slate){

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

 /**
  * AJAX submit an 'add to cart' form
  *
  * @param {jQuery} $form - jQuery instance of the form
  * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
  */
  ShopifyAPI.addItemFromForm = function($form) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function () {
        ShopifyAPI.getCart().then(function (data) {
          promise.resolve(data);
        });
      },
      error: function () {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getCart = function() {
    return $.getJSON('/cart.js');
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getProduct = function(handle) {
    return $.getJSON('/products/' + handle + '.js');
  };

 /**
  * Change the quantity of an item in the users cart
  *
  * @param {int} variantId - Variant to be adjust
  * @param {int} qty - New quantity of the variant
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.changeItemQuantity = function(variantId, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + variantId,
      dataType: 'json'
    });
  };

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function() {

    var $window = $(window);
    var $body = $('body');

    var selectors = {
      container: '[data-ajax-cart-container]',
      template: 'script[data-ajax-cart-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      header: '[data-ajax-cart-header]',
      body: '[data-ajax-cart-body]',
      footer: '[data-ajax-cart-footer]',
      item: '[data-ajax-item][data-id][data-qty]',
      itemRemove: '[data-ajax-cart-item-remove]',
      itemIncrement: '[data-ajax-cart-item-increment]',
      itemDecrement: '[data-ajax-cart-item-decrement]',
      shpfyElmt: '#shopify-section-ajax-cart'
    };

    var classes = {
      cartOpen: 'is-open',
    };

   /**
    * AjaxCart constructor
    *
    * Adds an `init` method with access to private variables inside the contructor
    */
    function AjaxCart() {
      this.name = 'ajaxCart'
      this.namespace = '.' + this.name;
      this.events = {
        RENDER:  'render'  + this.namespace,
        DESTROY: 'destroy' + this.namespace,
        SCROLL:  'scroll'  + this.namespace
      };

      // Cache products here as we fetch them via ajax so we can make less successive requests
      this.productStore = {};

      var initialized = false;
      var settings = {
        disableAjaxCart: false
      };

      this.$el         = $(selectors.container);
      this.stateIsOpen = null;

     /**
      * Initialize the cart
      *
      * @param {object} options - see `settings` variable above
      */
      this.init = function(options) {
        if(initialized) return;

        this.settings = $.extend(settings, options);

        if(!$(selectors.template).length){
          console.warn('['+this.name+'] - Handlebars template required to initialize AjaxCart');
          return;
        }

        // Compile this once during initialization
        this.template = Handlebars.compile($(selectors.template).html());

        // Add the AJAX part
        if(!this.settings.disableAjaxCart) {
          this._formOverride();
        }

        // Add event handlers here
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        $body.on('click', selectors.itemIncrement, this.onItemIncrementClick.bind(this));
        $body.on('click', selectors.itemDecrement, this.onItemDecrementClick.bind(this));
        $window.on(this.events.RENDER, this.onCartRender.bind(this));
        $window.on(this.events.DESTROY, this.onCartDestroy.bind(this));

        // Get the cart data when we initialize the instance
        ShopifyAPI.getCart().then(this.buildCart.bind(this));

        initialized = true;
        
        return initialized;
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

     /**
      * Call this function to AJAX-ify any add to cart forms on the page
      */
      _formOverride: function() {
        var _this = this;

        $body.on('submit', selectors.addForm, function(e) {
          e.preventDefault();

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);

          ShopifyAPI.addItemFromForm( $(e.target) )
            .then(function(data) {
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddSuccess.call(_this, data);
            })
            .fail(function(data) {
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddFail.call(_this, data) ;
            });
        }.bind(this));
      },

     /**
      * Ensure we are working with a valid number
      *
      * @param {int|string} qty
      * @return {int} - Integer quantity.  Defaults to 1
      */
      _validateQty: function(qty) {
        return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
      },

      _getItemRowAttributes: function(el) {
        var $el = $(el);
        var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

        return {
          $row: $row,
          id:  $row.data('id'),
          qty: this._validateQty($row.data('qty'))
        };
      },

     /**
      * Callback when adding an item is successful
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      onItemAddSuccess: function(cart){
        this.buildCart(cart);
        this.open();
      },

     /**
      * STUB - Callback when adding an item fails

      * @param {Object} data
      * @param {string} data.message - error message
      */
      onItemAddFail: function(data){
        //console.log('['+this.name+'] - onItemAddFail');
        console.warn('['+this.name+'] - ' + data.message);
      },

      /**
      * Callback for when the cart HTML is rendered to the page
      * Allows us to add event handlers for events that don't bubble
      */
      onCartRender: function(e) {
// 		console.debug('~~ ac render');
        /* CF-60 - if modal is not on screen it is labelled hidden */
        if ($(selectors.shpfyElmt).length > 0) { 
          $(selectors.shpfyElmt).removeAttr('aria-hidden').attr('aria-hidden','true'); 
          slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'hide');
        }
      },

     /**
      * Callback for when the cart HTML is removed from the page
      * Allows us to do cleanup on any event handlers applied post-render
      */
      onCartDestroy: function(e) {

      },

     /**
      * Builds the HTML for the ajax cart.
      * Modifies the JSON cart for consumption by our handlebars template
      *
      * @param {object} cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
      * @return ??
      */
      buildCart: function(cart) {

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        cart.items.map(function(item){
          item.image    = slate.Image.getSizedImageUrl(item.image, '200x');
          item.price    = slate.Currency.formatMoney(item.price, theme.moneyFormat);

          if(item.properties) {
            if(item.properties.shipping_interval_frequency && item.properties.shipping_interval_unit_type) {
              // Add property like "15 days"
              item.recharge_status = item.properties.shipping_interval_frequency + ' ' + item.properties.shipping_interval_unit_type;
            }
          }

          return item;
        });

        /**
         *  You can also use this as an intermediate step to constructing the AJAX cart DOM
         *  by returning an HTML string and using another function to do the DOM updating
         *
         *  return this.template(cart)
         *
         *  The code below isn't the most elegant way to update the cart but it works...
         */

        $window.trigger(this.events.DESTROY);
        $(selectors.container).empty().append( this.template(cart) );
        $window.trigger(this.events.RENDER);

        this.updateCartCount(cart);
      },

     /**
      * STUB - If your theme displays the cart count, use this method to udpate it
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      updateCartCount: function(cart) {
		$('.header__cart-badge-count').text(cart.item_count);
      },

     /**
      * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
      *
      * @param {event} e - Click event
      */
      onItemRemoveClick: function(e) {
        e.preventDefault();

        var attrs = this._getItemRowAttributes(e.target);
        ShopifyAPI.changeItemQuantity(attrs.id, 0).then(this.buildCart.bind(this));
      },

     /**
      * Increase the quantity of an item by 1
      *
      * @param {event} e - Click event
      */
      onItemIncrementClick: function(e) {
        e.preventDefault();
        //console.log('['+this.name+'] - onItemIncrementClick');

        var attrs = this._getItemRowAttributes(e.target);

        ShopifyAPI.changeItemQuantity(attrs.id, attrs.qty + 1).then(this.buildCart.bind(this));
      },

     /**
      * Decrease the quantity of an item by 1
      *
      * @param {event} e - Click event
      */
      onItemDecrementClick: function(e) {
        e.preventDefault();
        //console.log('['+this.name+'] - onItemDecrementClick');

        var attrs = this._getItemRowAttributes(e.target);
        var newQty = (attrs.qty < 1 ? 0 : attrs.qty - 1);

        ShopifyAPI.changeItemQuantity(attrs.id, newQty).then(this.buildCart.bind(this));
      },

     /**
      * Click the 'ajaxCart - trigger' selector
      *
      * @param {event} e - Click event
      */
      onTriggerClick: function(e) {
//         console.debug('~~ ac open');
        e.preventDefault();
        /* CF-60 - if modal is shown remove labelled hidden */
        if ($('#shopify-section-ajax-cart').length > 0) { 
          $('#shopify-section-ajax-cart').removeAttr('aria-hidden').attr('aria-hidden','false');
          slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'show');
        }
        this.toggleVisibility();
      },

     /**
      * Click the 'ajaxCart - close' selector
      *
      * @param {event} e - Click event
      */
      onCloseClick: function(e) {
//         console.debug('~~ ac close');
        e.preventDefault();
        //console.log('['+this.name+'] - onCloseClick');

        // Do any cleanup before closing the cart
        /* CF-60 - if modal is not on screen it is labelled hidden */
        if ($('#shopify-section-ajax-cart').length > 0) { 
          $('#shopify-section-ajax-cart').removeAttr('aria-hidden').attr('aria-hidden','true'); 
          slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'hide');
        }
        this.close();
      },

     /**
      * Opens / closes the cart depending on state
      *
      */
      toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
      },

     /**
      * Check the open / closed state of the cart
      *
      * @return {bool}
      */
      isOpen: function() {
        return this.stateIsOpen;
      },

     /**
      * Returns true is the cart is closed.
      *
      * @return {bool}
      */
      isClosed: function() {
        return !this.stateIsOpen;
      },

     /**
      * STUB METHOD - Code for opening the cart
      */
      open: function() {
        if(this.stateIsOpen) return;
       // console.log('['+this.name+'] - open');
        this.stateIsOpen = true;

        this.$el.addClass(classes.cartOpen);
      },

     /**
      * STUB METHOD - Code for closing the cart
      */
      close: function() {
        if(!this.stateIsOpen) return;

       // console.log('['+this.name+'] - close');
        this.stateIsOpen = false;

        this.$el.removeClass(classes.cartOpen);
      }
    });

    return AjaxCart;
  })();

})(jQuery, Handlebars, slate);

/**
 * AJAX Chimp
 * -----------------------------------------------------------------------------
 * Heavily modified version of the original jQuery plugin - https://github.com/scdoshi/jquery-ajaxchimp
 * Handles AJAX form submission and provides hooks for lifecycle events.
 *
 * @namespace ajaxChimp
 */

slate.AjaxChimp = (function($) {

  function AjaxChimp(form, options) {

    this.name = 'ajaxChimp'
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace
    };

    var _this = this;
    var defaults = {
      onInit: $.noop,
      onDestroy: $.noop,
      onBeforeSend: $.noop,
      onSubmitDone: $.noop,
      onSubmitFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));

    this.settings.onInit();

    return this;
  };

  AjaxChimp.prototype = $.extend({}, AjaxChimp.prototype, {
    regexes: {
      error: {
        1: /Please enter a value/,
        2: /An email address must contain a single @/,
        3: /The domain portion of the email address is invalid \(the portion after the @: (.+)\)/,
        4: /The username portion of the email address is invalid \(the portion before the @: (.+)\)/,
        5: /This email address looks fake or invalid. Please enter a real email address/,
        6: /.+\#6592.+/,
        7: /(.+@.+) is already subscribed to list (.+)\..+<a href.+/
      }
    },
    responses: {
      success: 'Thank you for subscribing!',
      error: {
        1: 'Please enter an email address',
        2: 'There was a problem with your entry. Please check the address and try again.',
        3: 'There was a problem with your entry. Please check the address and try again.',
        4: 'There was a problem with your entry. Please check the address and try again.',
        5: 'There was a problem with your entry. Please check the address and try again.',
        6: 'Too many subscribe attempts for this email address. Please try again in about 5 minutes.',
        7: 'You\'re already subscribed. Thank you!'
      }
    },
    getRegexMatch: function(string, stringKey) {
      var regexPatterns = this.regexes[stringKey];
      var matchedId;
      $.each(regexPatterns, function(id, regexPattern) {
        if (string.match(regexPattern) !== null) {
          matchedId = id;
          return false;
        }
      });
      return matchedId;
    },
    getMessageForResponse: function(response) {
      var msg;
      if (response.result === 'success') {
        msg = this.responses.success;
      } else {
        var index = -1;
        try {
          var parts = response.msg.split(' - ', 2);
          if (parts[1] === undefined) {
            msg = response.msg;
          } else {
            msg = parts[1];
          }
        } catch (e) {
          msg = response.msg;
        }

        // Now that we have the relevant part of the message, lets get the actual string for it
        var regexPattern = this.regexes.error;
        var matchedId = this.getRegexMatch(msg, 'error');
        if (matchedId && regexPattern[matchedId] && this.responses.error[matchedId]) {
          return msg.replace(regexPattern[matchedId], this.responses.error[matchedId]);
        }
      }

      return msg;
    },
    destroy: function() {
      this.$form.off(this.events.SUBMIT);
      this.settings.onDestroy();
    },
    onBeforeSend: function() {
      this.settings.onBeforeSend();
      if (this.$input.val() && this.$input.val().length) {
        this.$submit.prop('disabled', true);
        return true;
      } else {
        this.$input.parents('.form-group').addClass('alert-info');
      }
      return false;
    },
    onSubmitDone: function(response) {
      var success = response.result === 'success';
      var rspMsg = this.getMessageForResponse(response);

      this.$submit.prop('disabled', false);
      this.settings.onSubmitDone(success, rspMsg);
    },
    onSubmitFail: function() {
      this.settings.onSubmitFail();
    },
    onFormSubmit: function(e) {
      e.preventDefault();
      var _this = this;
      var $form = this.$form;
      var data = {};
      var dataArray = $form.serializeArray();

      // See - https://github.com/scdoshi/jquery-ajaxchimp/blob/master/jquery.ajaxchimp.js
      $.each(dataArray, function(index, item) {
        data[item.name] = item.value;
      });

      $.ajax({
          url: $form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
          dataType: 'jsonp',
          data: data,
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(response) {
          _this.onSubmitFail();
        });

      return false;
    }
  });

  return AjaxChimp;
})(jQuery)

/**
 * Slideshows
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slick.min.js
 *
 * @namespace - slideshow
*/

slate.Slideshow = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slide: '[data-slideshow-slide]',
    pauseToggle: '[data-slideshow-pause-toggle]'
  };

  var KEYS = {
    left: 37,
    right: 39
  };

 /**
  * Slideshow constructor
  *
  * @param {HTMLElement | $} el - The actual slideshow or slideshow wrapper
  * @param {Object} options - Options passed into the slider initialize function
  */
  function Slideshow(el, options) {

    var $el = $(el);

    this.$wrapper   = $el.is(selectors.slideshowWrapper) ? $el : $el.closest(selectors.slideShowWrapper);
    this.$slideshow = this.$wrapper.find(selectors.slideshow);

    var settings = {
      accessibility: true, // prevents page from jumping on focus - switched to 'true' for CF-60
      arrows: !Modernizr.touchevents,
      arrows: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      slidesToShow: this.$slideshow.data('slides-to-show') || 1,
      slidesToScroll: this.$slideshow.data('slides-to-scroll') || 1,
      autoplay: this.$slideshow.data('autoplay') || false,
      autoplaySpeed: this.$slideshow.data('speed') || 5000
    };

    this.settings = $.extend({}, settings, options);

    this.$wrapper.on('click', selectors.pauseToggle, this.onPauseToggleClick.bind(this));    
    this.$slideshow.on('init', this.slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);
    
    /* START CF-60 adding aria states to items within slides */
    this.$slideshow.on('init', function(evt) { 
//       console.debug('~~ Slideshow fire init');
      $(this).find('.slick-current').find('.slider-cta-button').removeAttr('aria-hidden').attr('tabindex',0);
    });    
    this.$slideshow.on('afterChange', function(evt) { 
//       console.debug('~~ Slideshow fire afterChange');
      $(this).find('.slick-current').find('.slider-cta-button').removeAttr('aria-hidden').attr('tabindex',0);
    });
    this.$slideshow.on('beforeChange', function(evt) { 
//       console.debug('~~ Slideshow fire beforeChange');
      $(this).find('.slick-current').find('.slider-cta-button').attr('aria-hidden','true').attr('tabindex',-1);
    });
	/* END CF-60 adding aria states to items within slides */
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
   /**
    * Adds events to the slideshow for improved accessibility
    *
    * @param {Event} evt - window event w/ type "init"
    * @param {Object} slick
    */
    slideshowA11y: function(evt, slick) {
      var self     = this;
      var $list    = slick.$list;
      var $dots    = slick.$dots;
      var $wrapper = this.$wrapper;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
          
      $wrapper.on('focusin', function(evt) {  
        console.debug('~~ Slideshow fire focusin');
        if (!$wrapper.has(evt.target).length) {
          return;
        }
        
        $list.attr('aria-live', 'polite');

        if (autoplay) {
          self.pause();
        }
      });

      // Resume autoplay
      $wrapper.on('focusout', function(evt) {
        console.debug('~~ Slideshow fire focusout');
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');

        if (autoplay) {
          self.play();
        }
      });
      
      // Add arrow key support when focused
      if ($dots) {
        $dots.on('keydown', function(evt) {
          if (evt.which === KEYS.left) {
            self.prev();
          }

          if (evt.which === KEYS.right) {
            self.next();
          }

          // Update focus on newly selected tab
          if ((evt.which === KEYS.left) || (evt.which === KEYS.right)) {
            $dots.find('.slick-active button').focus();
          }
        });
      }
    },

    next: function() {
      console.debug('~~ Slideshow fire next');
      this.$slideshow.slick('slickNext');
    },

    prev: function() {
      console.debug('~~ Slideshow fire prev');
      this.$slideshow.slick('slickPrev');
    },

    pause: function() {
      console.debug('~~ Slideshow fire play');
      this.$slideshow.slick('slickPause');
    },

    play: function() {
      console.debug('~~ Slideshow fire play');
      this.$slideshow.slick('slickPlay');
    },

    unpause: function() {
      console.debug('~~ Slideshow fire unpause');
      if(this.settings.autoplay) {
        this.play();
      }
    },

    togglePause: function() {
      console.debug('~~ Slideshow fire togglepause');     
      var slick = this.$slideshow.slick('getSlick');

      if(this.settings.autoplay){
        if(slick.paused){
          this.unpause();
        }
        else {
          this.pause();
        }
      }
    },

   /**
    * Finds and displays a slide associated with the blockId passed in.
    * Note:  Block IDs are not required on slides for the slideshow to work
    *        If used, the element matching `selectors.slide` must have a data-block-id attribute
    *
    * @param {string} blockId
    */
    goToSlideByBlockId: function(blockId) {
      var $slide = $(selectors.slide, this.$slideshow).filter('[data-block-id="' + blockId + '"]:not(.slick-cloned)');
      
      this.$slideshow.slick('slickGoTo', $slide.data('slick-index') );
    },

    onPauseToggleClick: function(evt) {
      evt.preventDefault();
      this.togglePause();
    }
  });

  return Slideshow;
}(jQuery, Modernizr));

/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend( $.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
  });

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base:     300
 // fast:     150,
 // slow:     600
  };

 /**
  * Get one of the durations stored in the variable defined above
  * If the requested duration doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - duration in ms
  */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if(_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  }

  return {
    getTransitionTimingDuration: getTransitionTimingDuration
  };

}(jQuery));

/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_cf_';

 /**
  * User constructor
  */
  function User() {
    this.name = 'user'
    this.namespace = '.' + this.name;

    // Do any initialization here
    // For instance, you could increment a cookie that tracks visits to the site

    return this;
  };

  User.prototype = $.extend({}, User.prototype, {

   /**
    * Library of cookies to use throughout the site.
    * Use the `createCookie` method below to create your own copies of these.  Don't access these directly.
    */
    _cookies: {
      subscriptionSlideUpSeen: {
        name: cookiePrefix + 'subscriptionSlideUp_seen',
        value: true
      },
      emailCollected: {
        name: cookiePrefix + 'emailCollected',
        value: true
      }
    },

   /**
    * Creates and returns a copy of one of the cookies available above
    *
    * @param {String} key
    * @return {Object | undefined}
    */
    createCookie: function(key) {
      if(this._cookies.hasOwnProperty(key)) {
        return $.extend(true, {}, this._cookies[key]);
      }
    },

   /**
    * Sets a browser cookie
    *
    * @param {Object} cookie
    * @param {String} cookie.name
    * @param {String} cookie.value
    * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
    */
    setCookie: function(cookie) {
      if(this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value){
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires : cookie.expiration } : {};
      Cookies.set( cookie.name, cookie.value, opts );

      return this;
    },

   /**
    * Checks for the presence of a browser cookie by name (doesn't check for value equality)
    *
    * @param {String} cookieName
    * @return {Boolean}
    */
    hasCookie: function(cookieName) {
      return typeof Cookies.get( cookieName ) !== "undefined";
    },

   /**
    * Returns value of browser cookie by name
    *
    * @param {String} cookieName
    * @return {String | Undefined}
    */
    getCookieValue: function(cookieName) {
      return this.hasCookie( cookieName ) ? Cookies.get( cookieName ) : undefined;
    },

   /**
    * Removes a cookie by name
    *
    * @param {String} cookieName
    * @return {Self}
    */
    removeCookie: function(cookieName) {
      Cookies.remove( cookieName )
      return this;
    }
  });

  return new User();

}(Cookies));

/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width(); 

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1480
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };

  var _selectors = {
    mobile_menu: '[data-mobile-menu]',
    desktop_menu: '[data-desktop-menu]',
    header: '[data-header]',
    mobile_hide: '.interactive-mobile-hide',
    desktop_hide: '.interactive-desktop-hide'
  };
  
 /**
  * Get one of the widths stored in the variable defined above
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - pixel width
  */
  function getBreakpointMinWidth(key) {
    if(!key) return;

    if(_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

 /**
  * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
  * So if we pass in a width between 'sm' and 'md', this will return 'sm'
  *
  * @param {int} w - width
  * @return {undefined|string} foundKey
  */
  function getBreakpointMinWidthKeyForWidth(w) {
    var w = w != undefined ? w : $window.width();
    var previousKey;
    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if(w > bpMinWidth) {
        previousKey = k;
      }
      else {
        foundKey = previousKey;
      }
    });

    return foundKey;
  }

  /* CF-45 - things that are not visible to mobile still appear in DOM, they should be labelled accordingly */
  function applyAccessibilityOnHidden(width) {
    setTimeout(function() { 
//       console.debug('~~ new width: ' + width);
      
      if (width < _breakpointMinWidths.md) {
      	$(_selectors.desktop_menu).removeAttr('aria-hidden').attr('aria-hidden','true').attr('tabindex',-1);
        $(_selectors.desktop_menu).find(_selectors.mobile_hide).removeAttr('aria-hidden').attr('aria-hidden','true').attr('tabindex',-1);
        $(_selectors.mobile_menu).removeAttr('aria-hidden').attr('aria-hidden','false').removeAttr('tabindex');
        $(_selectors.mobile_menu).find(_selectors.desktop_hide).removeAttr('aria-hidden').attr('aria-hidden','false').removeAttr('tabindex');
      } else {
      	$(_selectors.desktop_menu).removeAttr('aria-hidden').attr('aria-hidden','false').removeAttr('tabindex');
        $(_selectors.desktop_menu).find(_selectors.mobile_hide).removeAttr('aria-hidden').attr('aria-hidden','false').removeAttr('tabindex');
        $(_selectors.mobile_menu).removeAttr('aria-hidden').attr('aria-hidden','true').attr('tabindex',-1);
        $(_selectors.mobile_menu).find(_selectors.desktop_hide).removeAttr('aria-hidden').attr('aria-hidden','true').attr('tabindex',-1);
      }
      
    },500);
  }

 /**
  * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
  *
  */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if( (newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth) ) {
        
        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
    
    /* CF-45 - apply proper accessible visibility on hidden elements */
    applyAccessibilityOnHidden(cachedWindowWidth);
  }

  $window.on('resize', $.throttle(20, onResize) );

  return {
    getBreakpointMinWidth: getBreakpointMinWidth,
    applyAccessibilityOnHidden: applyAccessibilityOnHidden
  };

}(jQuery));

/**
 * Product Card Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the product card html (see snippets/product-card.liquid)
 */

slate.productCard = (function() {

  var selectors = {
    el: '[data-product-card]',
    altLazyImg: '[data-product-card-alt-lazy]'
  };

  var $productCard = $(selectors.el);

  if(!$productCard.length) {
    return;
  }
  
  var events = window.PointerEvent ? {
              end:   "pointerup",
              enter: "pointerenter",
              leave: "pointerleave"
            } : {
              end: "touchend",
              enter: "mouseenter",
              leave: "mouseleave"
            };


  $(selectors.el).on(events.enter, onEnter);

  function onEnter(e) {
    var $productCard = $(e.currentTarget);
    var $lazyImg = $productCard.find( selectors.altLazyImg );

    if($lazyImg.length) {
      $lazyImg.css('opacity', 0);
      $lazyImg.on('load', function() {
        $(this).css('opacity', '');
      });
      $lazyImg.attr('src', $lazyImg.data('src'));
      $lazyImg.removeAttr('data-src');
    }
  };

}());

/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * TODO: revisit and refactor onDiscountPriceRadioClick and updateProductPrices
 *
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 *
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant galleries + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency)
 */

// Requires slate for slate.Currency

slate.ProductDetailForm = (function($, Modernizr, slate) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productZoomButton: '[data-zoom-button]',
    productGallery: '[data-product-gallery]',
    productGallerySlideshow: '[data-product-gallery-slideshow]',
    productGallerySlideLink: '[data-product-gallery-slide-link]',
    productGalleryThumbnail: '[data-product-gallery-thumbnail]',
    productGalleryThumbnailSlide: '[data-product-gallery-thumbnail-slide]',
    initialSlide: '[data-initial-slide]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productPriceDisplay: '[data-product-price-display]',
    productSubscriptionPrice: '[data-product-subscription-price]',
    productSubscriptionLabel: '[data-product-subscription-label]',
    singleOptionSelector: '[data-single-option-selector]',
    variantOptionValueList: '[data-variant-option-value-list]',
    variantOptionValue: '[data-variant-option-value]',
    quantitySelect: '[data-product-quantity-select]',
    lowInventoryMessage: '[data-low-inventory-msg]',
    lowInventoryThresholdQty: '[data-low-inventory-threshold]',
    variantInventoryQty: '[data-variant-inventory-qty]',
    fullDetailsLink: '[data-full-details-link]'
  };

  var classes = {
    hide: 'hide',
    variantOptionValueActive: 'is-active',
    zoomReady: 'is-zoomable',
    zoomedIn: 'is-zoomed'
  };

  var $window   = $(window);

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   * @param { Boolean } config.enableZoom - Toggle zoom capabilities on / off
   * @param { Boolean } config.enableHistoryState - If set to "true", turns on URL updating when switching variants
   * @param { Function } config.onReady -  Called after the product form is initialized.
   */
  function ProductDetailForm(config) {

    this.settings = {};
    this.name = 'productDetailForm';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize' + this.namespace,
      CLICK:  'click'  + this.namespace,
      READY:  'ready'  + this.namespace,
      CHANGE: 'change' + this.namespace
    };

    var ready = false;
    var options = options || {};
    var defaults = {
      enableZoom: true,
      enableHistoryState: true
    };

    this.initialize = function() {
      if(ready) {
        return;
      }

      this.settings = $.extend({}, defaults, config);

      if (!this.settings.$el || this.settings.$el == undefined) {
        console.warn('['+this.name+'] - $el required to initialize');
        return;
      }

      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      this.productSingleObject  = JSON.parse($(selectors.productJson, this.$container).html());

      slate.utils.chosenSelects(this.$container);

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.QUANTITY_SELECT_LIMIT = this.$container.find(selectors.quantitySelect).first().data('max') || 4;

      this.variants = new slate.Variants(variantOptions);

      // See slate.Variants
      this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));

      this.initGalleries();

      this.$container.on(this.events.CLICK, selectors.variantOptionValue, this.onVariantOptionValueClick.bind(this));
      this.$container.on(this.events.CHANGE, selectors.quantitySelect, this.onQuantitySelectChange.bind(this));

      // Create an observer instance linked to the callback function
      if ($(selectors.productPrice, this.$container).length > 0) {
        var observer = new MutationObserver(this.updateDisplayPriceBasedOnLabel.bind(this));
        observer.observe($(selectors.productPrice, this.$container).get(0), { childList: true });
      }

      var e = $.Event(this.events.READY);
      this.$el.trigger(e);

      ready = true;
    };

    return this;
  };

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {
     //var varsize = "";
     

    initGalleries: function() {
      var self = this;
      var $galleries = $(selectors.productGallery, this.$container);
      if ($('.chosen-single span').length > 0){
         $('.price-wrapper sup').html(" "+ $('.chosen-single span').html());
      }
      if ($('#SingleOptionSelector-0 option:selected').length > 0){
         $('.price-wrapper sup').html(" "+ $('#SingleOptionSelector-0 option:selected').html());
      }
      
      
      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function initHoverZoom($zoomTarget) {
        var opts = {
          url: $zoomTarget.find(selectors.productGallerySlideLink).attr('href'),
          on: 'click',
          touch: false,
          escToClose: true,
          zoomMagnify: 0.8,
          zoomDuration: 300,
          callback: function() {
            $zoomTarget.addClass(classes.zoomReady);
          },
          onZoomIn: function() {
            $zoomTarget.addClass(classes.zoomedIn);
          },
          onZoomOut: function() {
            $zoomTarget.removeClass(classes.zoomedIn);
          }
        };

        $zoomTarget.zoom(opts);

        $zoomTarget.find(selectors.productZoomButton).on('click', function(e){
          $zoomTarget.trigger('click');
          return false;
        });

      }

      function destroyHoverZoom($zoomTarget) {
        $zoomTarget.trigger('zoom.destroy');
        $zoomTarget.find(selectors.productZoomButton).off('click');
      }

      function onSlideshowSlickBeforeChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.enableZoom && $zoomTarget.find('.preview-wrapper').length == 0) {
          destroyHoverZoom($zoomTarget);
        }
      }

      function onSlideshowSlickAfterChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        // no hover zoom for video previews
        if(self.settings.enableZoom && $zoomTarget.find('.preview-wrapper').length == 0) {
          initHoverZoom($zoomTarget);
        }
        $galleries.find('iframe').each(function(){
          $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');    
        });
      }

      function onSlideshowSlickInit(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        // no hover zoom for video previews
        if(self.settings.enableZoom && $zoomTarget.find('.preview-wrapper').length == 0) {
          initHoverZoom($zoomTarget);
        }
        // full-height video preview
        setTimeout(function(){
          $(slick.$slides).each(function(){
            var height = $(this).height();
            $(this).find('.preview-wrapper img').height(height);
          });
        });
      }

      $galleries.each(function() {
        var $slideshow = $(this).find(selectors.productGallerySlideshow);
        var $thumbnail = $(this).find(selectors.productGalleryThumbnail);

        // Look for element with the initialSlide selector.
        var initialSlide = $(this).find(selectors.initialSlide).length ? $(this).find(selectors.initialSlide).index() : 0;

        $slideshow.on({
          init: onSlideshowSlickInit,
          beforeChange: onSlideshowSlickBeforeChange,
          afterChange: onSlideshowSlickAfterChange
        });

        $slideshow.slick({
          speed: 600,
          dots: true,
          swipe: Modernizr.touchevents,
          arrows: !Modernizr.touchevents,
          asNavFor: '#' + $thumbnail.attr('id'),
          initialSlide: initialSlide,
          accessibility: true, // switched to 'true' for CF-60
          centerMode: false,
          infinite: false,
          draggable: true,
          responsive: [{
            breakpoint: 576,
            settings: { speed: 100 }
          }]
        });

        $thumbnail.on('click', selectors.productGalleryThumbnailSlide, function() {
          $slideshow.slick('slickGoTo', $(this).data('slick-index'));
        });

        $thumbnail.slick({
          speed: 600,
          slidesToShow: 3, // Slick has trouble when slidesToShow = slide number
          slidestoScroll: 1,
          arrows: false,
          asNavFor: '#' + $slideshow.attr('id'),
          initialSlide: initialSlide,
          accessibility: true, // switched to 'true' for CF-60
          centerMode:false,
          infinite: false,
          draggable: false,
          responsive: [{
            breakpoint: 576,
            settings: { speed: 100 }
          }]
        });
      });

      // Because slick can get weird on initialization, make sure we call `refresh` on any visible galleries
      $galleries.not('.hide').each(function() {
        var $variantGallery = $(this);
        $variantGallery.find(selectors.productGallerySlideshow).slick('getSlick').refresh();
        $variantGallery.find(selectors.productGalleryThumbnail).slick('getSlick').refresh();
      });
    },

    /**
     * Slick sliders are annoying and sometimes need an ass kicking
     *
     */
    resizeGalleries: function() {
      $('.slick-slider', this.$container).resize();
    },

    onVariantChange: function(evt) {
      var variant = evt.variant;

      this.updateProductPrices(variant);
      this.updateAddToCartState(variant);
      this.updateQuantityDropdown(variant);
      this.updateVariantOptionValues(variant);
      this.updateFullDetailsLink(variant);
      this.updateVariantInventoryQtyMessage(variant);
      this.updateGalleries(variant);   
      //varsize= variant.title;
      $(selectors.singleOptionSelector, this.$container).trigger('chosen:updated');

    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */
    updateAddToCartState: function(variant) {

      var $addToCartBtn     = $(selectors.addToCart, this.$container);
      var $addToCartBtnText = $(selectors.addToCartText, this.$container);
      var $priceWrapper     = $(selectors.priceWrapper, this.$container);

      if (variant) {
        $priceWrapper.removeClass(classes.hide);
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.unavailable);
        $priceWrapper.addClass(classes.hide);
        return;
      }

      if (variant.available) {
        $addToCartBtn.prop('disabled', false);
        $addToCartBtnText.html(theme.strings.addToCart);
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the quantity select dropdown based on the available quantity and inventory management setting of the selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateQuantityDropdown: function(variant) {

      // rerun updateProductPrices

      var $select = $(selectors.quantitySelect, this.$container);

      // Close the dropdown while we make changes to it
      $select.trigger('chosen:close');

      // Not sure what's going on here?  variant is missing object properties somehow??
      if(variant && variant.inventory_management && variant.inventory_policy == "deny") {
        if(variant.inventory_quantity > 0) {
          $select.prop('disabled', false);

          // Update the select box to max out at the limit if less than 5?
          var limit = (variant.inventory_quantity > this.QUANTITY_SELECT_LIMIT ? this.QUANTITY_SELECT_LIMIT : variant.inventory_quantity);

          $select.empty();

          for (var i = 1; i <= limit; i++) {

            var option = document.createElement('option');
                option.value = i;
                option.text  = i;

            $select.append(option);
          }
        }
        else {
          $select.prop('disabled', true);
        }
      }
      else {
        $select.prop('disabled', false);
      }

      $select.trigger('chosen:updated');

    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     */
    updateProductPrices: function(variant) {
      var $productPrice = $(selectors.productPrice, this.$container);
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $productQty   = $(selectors.quantitySelect, this.$container);
      var $compareEls   = $comparePrice.add( $(selectors.comparePriceText, this.$container) );


      if(variant) {

        // multiply by qty value
        $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat) +"<sup>("+variant.title+")</sup>");

        // look for recharge stuff
        // if recharge form -> look for selected radio on current variant

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) +"<sup>("+variant.title+")</sup>");
          $compareEls.removeClass(classes.hide);
        } else {
          $comparePrice.html('');
          $compareEls.addClass(classes.hide);
        }
      }
      
    },

    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantOptionValues: function(variant) {
      if(variant) {
        // Loop through all the options and update the option value
        for (var i = 3; i >= 1; i--) {
          var variantOptionValue = variant['option' + i];
          var $variantOptionValueUI = $('[data-variant-option-value="'+variantOptionValue+'"]', this.$container);

          $variantOptionValueUI.addClass( classes.variantOptionValueActive );
          $variantOptionValueUI.siblings().removeClass( classes.variantOptionValueActive );
        }
      }
    },

    /**
     * Used on quick view, updates the "view full details" link to point to the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateFullDetailsLink: function(variant) {
      var $fullDetailsLink = $(selectors.fullDetailsLink, this.$container);
      var updatedUrl;

      if(variant && $fullDetailsLink.length) {
        updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter('variant', variant.id, $fullDetailsLink.attr('href'));
        $fullDetailsLink.attr('href', updatedUrl);
      }
    },

    /**
     * Updates low inventory messaging, hides it if inventory tracking is disabled or stock is high enough
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantInventoryQtyMessage: function(variant) {

      var $msg = $(selectors.lowInventoryMessage, this.$container);
      var $qty = $(selectors.variantInventoryQty, this.$container);
      var threshold = parseInt($(selectors.lowInventoryThresholdQty, this.$container).data('low-inventory-threshold'));

      if(!variant) {
        $msg.slideUp();
        return;
      }

      var qty = variant.inventory_quantity;
      var policy = variant.inventory_policy;
      var management = variant.inventory_management;

      if(qty == 0 || qty > threshold || policy == "continue" || management == null) {
        $msg.slideUp(300, function(){
          $qty.text(qty);
        });
      }
      else {
        $qty.text(qty);
        if(!$msg.is(':visible')) {
          $msg.slideDown(300);
        }
      }
    },

    /**
     * Look for a gallery matching one of the selected variant's options and switch to that gallery
     * If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     */
    updateGalleries: function(variant) {

      var $galleries = $(selectors.productGallery, this.$container);
      var $galleryFeatured = $(selectors.productGalleryFeatured, this.$container);

      if (variant) {
        if ($galleries.length > 1) {
          for (var i = 3; i >= 1; i--) {
            var option = variant['option' + i];
            var $variantGallery = $galleries.filter(function() {
              return $(this).data('variant-gallery') == option;
            });

            if ($variantGallery.length && $variantGallery.hasClass(classes.hide)) {
              $galleries.not($variantGallery).addClass(classes.hide);
              $variantGallery.removeClass(classes.hide);
              // Slick needs to make a lot of measurements in order to work, calling `refresh` forces this to happen
              $variantGallery.find(selectors.productGallerySlideshow).slick('getSlick').refresh();
              $variantGallery.find(selectors.productGalleryThumbnail).slick('getSlick').refresh();
            }
          }
        }
        else {
          // Slide to featured image for selected variant
          if (variant.featured_image) {
            var $imageSlide = $galleryFeatured.find('[data-image="'+variant.featured_image.id+'"]').first();

            if ($imageSlide.length) {
              $galleryFeatured.slick('slickGoTo', $imageSlide.data('slick-index'));
            }
          }
        }
      }
      else {
        // No variant - Don't do anything?
      }
    },

    /**
     * Handle variant option value click event.
     * Update the associated select tag and update the UI for this value
     *
     * @param {event} evt
     */
    onVariantOptionValueClick: function(e) {

      var $option = $(e.currentTarget);

      if ($option.hasClass(classes.variantOptionValueActive)) {
        return;
      }

      var value     = $option.data('variant-option-value');
      var position  = $option.parents(selectors.variantOptionValueList).data('option-position');
      var $selector = $(selectors.singleOptionSelector, this.$container).filter('[data-index="option'+position+'"]');

      $selector.val(value);
      $selector.trigger('change');     

      $option.addClass(classes.variantOptionValueActive);
      $option.siblings().removeClass( classes.variantOptionValueActive );

    },

    onQuantitySelectChange: function(e) {
      this.updateDisplayPriceBasedOnLabel();
    },

    updateDisplayPriceBasedOnLabel: function() {
      var $priceLabel = $(selectors.productPrice, this.$container);
      var priceLabelValue = $priceLabel.text();
      var deFormattedDiscountPrice = parseFloat(priceLabelValue.replace(/[^0-9-.]/g, ''));
      var qty = $(selectors.quantitySelect, this.$container).val();

      var priceText = slate.Currency.formatMoney(deFormattedDiscountPrice * qty * 100);


      $(selectors.productPriceDisplay, this.$container).html( priceText +"<sup></sup>");        
       if ($('.chosen-single span').length > 0){
         $('.price-wrapper sup').html(" "+ $('.chosen-single span').html());
      }
      if ($('#SingleOptionSelector-0 option:selected').length > 0){
         $('.price-wrapper sup').html(" "+ $('#SingleOptionSelector-0 option:selected').html());
      }
    }
  });

  return ProductDetailForm;

})(jQuery, Modernizr, slate)

/**
 * Quick View Script
 * ------------------------------------------------------------------------------
 *
 * Handles all logic related to quick view inside .product-card elements
 * Attaches click handler to `[data-quickview-trigger]` elements which are links pointing to the quickview template of a product.
 * If the quick view has been seen before, it will display it
 * If not, it will AJAX in the quick view, and *then* display it
 *
 * Requires:
 *  - jQuery
 *  - jQuery.imagesLoaded
 *  - Modernizr (for Modernizr.csstransitions)
 *  - Slate (for slate.ProductDetailForm)
 */

slate.quickView = (function($, Modernizr, slate) {

  var $window = $(window);
  var $body = $(document.body)

  var selectors = {
    quickView: '[data-quick-view]',
    quickViewContentsBody: '[data-quick-view-contents-body]',
    quickViewClose: '[data-quick-view-close]',
    quickViewTrigger: '[data-quick-view-trigger]',
    productCardContents: '[data-product-card-contents]',
    productDetailForm: '[data-product-detail-form]'
  };

  var classes = {
    quickViewIsOpen: 'is-open',
    productCardHasOpenQuickView: 'has-open-quick-view'
  };

  function QuickViewsManager(quickViewConstructor) {
    this.name = 'quickViewsManager';
    this.quickViews = {};

    var isLoadingQuickView = false;

    this.register = function(id, qv) {
      if( !(qv instanceof quickViewConstructor) ) {
        console.warn('['+this.name+'] - instance of quickView required when calling register');
        return;
      }

      if(!this.quickViews.hasOwnProperty(id)) {
        this.quickViews[id] = qv;
      }

      return this;
    };

    this.getQuickViewByID = function(id) {
      return this.quickViews[id];
    };

    this.onResize = function() {
      $.each(this.quickViews, function(i, qv){
        qv.onResize();
      });
    };

    this.getOpenQuickViews = function() {
      var opens = [];

      $.each(this.quickViews, function(i, qv) {
        qv.isOpen() && opens.push(qv);
      });

      return opens;
    },

    this.closeOpenQuickViews = function(cb) {
      var opens = this.getOpenQuickViews();

      if(opens.length == 0 ) {
        cb();
      }
      else {
        $.each(opens, function(i, qv) {
          if(i==0) {
            qv.$productCard.one('closed.quickView', cb);  
          }
          qv.close();
        });
      }

    };

    this.onQuickViewTriggerClick = function($trigger) {
      if($trigger == undefined) {
        return;
      }

      var quickViewsManager = this;
      var $productCard      = $trigger.parents('.product-card');
      var id                = $productCard.attr('id');
      var quickView         = this.getQuickViewByID(id);

      if(quickView == undefined) {

        if(isLoadingQuickView) return; // Return early, we're already fetching a quick view, sorry!

        isLoadingQuickView = true;

        // generate a new QV
        quickView = new QuickView({
          $productCard: $productCard,
          url: $trigger.attr('href')
        });

        $productCard.one('loaded.quickView', function() {
          isLoadingQuickView = false;
          quickViewsManager.closeOpenQuickViews( quickView.open.bind(quickView) ); // Make sure all the QVs are closed before opening this new one
        });

        quickViewsManager.register(id, quickView);
      }
      else {
        if(!quickView.isOpen()) {
          quickViewsManager.closeOpenQuickViews( quickView.open.bind(quickView) );  
        }
      }
    };

    $window.on('resize', $.throttle(50, this.onResize.bind(this)));

    return this;
  };

  /**
   * QuickView constructor
   *
   * @param { Object } settings
   * @param { HTMLElement | jQuery } settings.$productCard
   * @param { String } settings.url - URL pointing to the quick view of the product
   * @param { Function } settings.onProductDetailFormReady - Called after the product form is initialized.  `this` references the QuickView instance
   */
  function QuickView(options) {

    this.name = 'quickView';
    this.namespace = '.'+this.name;

    var self = this;
    var defaults = {
      onProductDetailFormReady: $.noop,
      transitionDuration: 800,
      transitionTimingFunction: 'ease-in-out'
    };

    this.settings = $.extend({}, defaults, options);

    if(typeof this.settings.$productCard == undefined) {
      console.warn('['+this.name+'] - $productCard element required to initialize');
      return;
    };

    if(typeof this.settings.url != "string" || this.settings.url.length == 0 || this.settings.url.indexOf('quick-view') == -1) {
      console.warn('['+this.name+'] - valid URL required to initialize');
      return;
    };

    // Elements we'll need for everything to work
    this.$productCard           = this.settings.$productCard;
    this.$productCardContents   = this.$productCard.find(selectors.productCardContents);
    this.$productDetailForm     = null;
    this.$quickView             = null;
    this.$quickViewContentsBody = null
    this.$close                 = null;

    this.stateIsOpen               = false;
    this.supportsCssTransitions    = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
    this.productDetailFormInstance = null

    this.events = {
      OPEN:   'open'   + this.namespace,
      OPENED: 'opened' + this.namespace,
      CLOSE:  'close'  + this.namespace,
      CLOSED: 'closed' + this.namespace,
      LOADED: 'loaded' + this.namespace
    };

    this.$productCard.on('click', selectors.quickViewClose, this.onCloseClick.bind(this));

    this.$productCard.height( this.$productCardContents.outerHeight(true) );

    // Initial ajax request to get the quick view content
    $.get(this.settings.url, this._onAjaxSuccess.bind(this))

    return this;
  };

  QuickView.prototype = {

    /**
     * Initial AJAX Call callback
     * Gets the returned HTML, adds it to the DOM, sets the instance's dom element variables, initializes the product detail form
     *
     */
    _onAjaxSuccess: function(ajaxResponse) {
      this.$productCard.append( $(ajaxResponse) );

      this.$productDetailForm     = this.$productCard.find(selectors.productDetailForm);
      this.$quickView             = this.$productCard.find(selectors.quickView);
      this.$quickViewContentsBody = this.$productCard.find(selectors.quickViewContentsBody);
      this.$close                 = this.$quickView.find(selectors.quickViewClose);

      this.$productDetailForm.on('ready.productDetailForm', this.onProductDetailFormReady.bind(this));

      var config = {
        $el: this.$productDetailForm,
        zoomEnabled: true,
        enableHistoryState: false
      };

      this.productDetailFormInstance = new slate.ProductDetailForm(config);
      this.productDetailFormInstance.initialize();

      // Fire off the loaded event once all the images in the quick view are loaded
      this.$quickView.imagesLoaded()
        .always( function() {
          var e = $.Event(this.events.LOADED);
          this.$productCard.trigger(e);          
        }.bind(this));

    },

    /**
     * Called after the product detail form is done initializing
     */
    onProductDetailFormReady: function() {
      this.settings.onProductDetailFormReady.call(this);
    },

    open: function() {

      this.onOpen();

      if(this.isOpen()) {
        return;
      }

      this.stateIsOpen = true;
      this.doOpenAnimation();
    },

    close: function() {

      this.onClose();

      if(this.isClosed()) {
        return;
      }

      this.stateIsOpen = false;
      this.doCloseAnimation();
    },

    isOpen: function() {
      return this.stateIsOpen;
    },

    isClosed: function() {
      return !this.isOpen();
    },

    /**
     * Called after this.open is called but before any opening animation has run
     */
    onOpen: function() {
      this.$productCard.addClass(classes.productCardHasOpenQuickView);
      var e = $.Event(this.events.OPEN);
      this.$productCard.trigger(e);
    },

    /**
     * Called after this.close is called but before any closing animation has run
     */
    onClose: function() {
      this.$productCard.removeClass(classes.productCardHasOpenQuickView);
      var e = $.Event(this.events.CLOSE);
      this.$productCard.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onOpened: function() {
      var e = $.Event(this.events.OPENED);
      this.$productCard.trigger(e);

    },

    /**
     * Called after the closing animation has run
     */
    onClosed: function() {
      var e = $.Event(this.events.CLOSED);
      this.$productCard.trigger(e);
      this.$quickView.removeClass(classes.quickViewIsOpen);
    },

    doOpenAnimation: function() {

      this.$quickView.addClass(classes.quickViewIsOpen);

      var productCardContentsHeight = this.$productCardContents.outerHeight(true);
      var qvHeight = this.$quickViewContentsBody.outerHeight(true);
      
      this.$productCard.height(productCardContentsHeight);
      this.$quickView.height(0);

      this.setTransitions();
      
      this.$productCard.height(productCardContentsHeight + qvHeight);
      this.$quickView.height(qvHeight);

      if(this.supportsCssTransitions) {
        this.$quickView.one(slate.utils.whichTransitionEnd(), this.onOpened.bind(this));
      }
      else {
        this.onOpened();
      }
    },

    doCloseAnimation: function() {
      this.stateIsOpen = false;
      
      var productCardContentsHeight = this.$productCardContents.outerHeight(true);

      this.$productCard.height(productCardContentsHeight);
      this.$quickView.height(0);

      if(this.supportsCssTransitions) {
        this.$quickView.one(slate.utils.whichTransitionEnd(), this.onClosed.bind(this));
      }
      else {
        this.onClosed();
      }
    },

    onResize: function() {
      var qvHeight = this.$quickViewContentsBody.outerHeight(true);
      var pccHeight = this.$productCardContents.outerHeight(true);

      if(this.isClosed()) {
        this.$productCard.height(pccHeight);
      }
      else {
        this.$productCard.height(pccHeight + qvHeight);
        this.$quickView.height(qvHeight);
      }
    },

    setTransitions: function() {
      var trans = 'height ' + this.settings.transitionDuration + 'ms ' + this.settings.transitionTimingFunction;
      this.$quickView.css( 'transition', trans);
      this.$productCard.css( 'transition', trans);
    },

    scrollToProductCard: function() {
      $('html, body').animate( { scrollTop : (this.$productCard.offset().top - 100) } );
    },
    scrollToQuickView: function() {
      $('html, body').animate( { scrollTop : this.$quickView.offset().top } );
    },
    onCloseClick: function(e) {
      e.preventDefault();
      this.close();
    }
  };


  $(function() {
    var quickViewsManager = new QuickViewsManager(QuickView);

    $body.on('click', selectors.quickViewTrigger, function(e) {
      e.preventDefault();
      quickViewsManager.onQuickViewTriggerClick($(this));
    });
  });

}(jQuery, Modernizr, slate));

/**
 * AJAX Klaviyo Library
 * -----------------------------------------------------------------------------
 * Handles AJAX form submission and callback event
 *
 * @namespace ajaxKlaviyo
 */

slate.AjaxKlaviyoForm = (function($) {

 /**
  * AJAX Klaviyo Form Contrustor
  *
  * @param {HTMLElement | jQuery} form - Form element
  * @param {Object} options
  * @param {String} options.listId - Klaviyo List ID
  * @param {String} options.source - Klaviyo custom $source property
  * @param {Function} options.onInit
  * @param {Function} options.onBeforeSend
  * @param {Function} options.onSubmitFail  
  * @param {Function} options.onSubscribeSuccess
  * @param {Function} options.onSubscribeFail
  * @return {self}
  */
  function AjaxKlaviyoForm(form, options) {

    this.name = 'ajaxKlaviyoForm'
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace
    };

    var _this = this;
    var defaults = {
      source: "Shopify Form",
      onInit: $.noop,
      onBeforeSend: $.noop,
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);

    if(!this.settings.listId) {
      console.warn('['+this.name+'] - Valid Klaviyo List ID required to initialize');
      return;
    }

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));

    this.settings.onInit();

    return this;
  };

  AjaxKlaviyoForm.prototype = $.extend({}, AjaxKlaviyoForm.prototype, {
    onBeforeSend: function() {
      
      if(this.settings.onBeforeSend() == false) {
        return false;
      }

      if (this.$input.val() && this.$input.val().length) {
        this.$submit.prop('disabled', true);
        return true;
      } else {
        this.$input.parents('.form-group').addClass('alert-info');
      }

      return false;
    },
    onSubmitDone: function(response) {

      this.$submit.prop('disabled', false);

      if(response.success) {
        this.settings.onSubscribeSuccess();
      }
      else {
        this.settings.onSubscribeFail();
      }
    },
    onSubmitFail: function(errors) {

      this.$submit.prop('disabled', false);

      if(errors instanceof Array && errors.length) {
        for (var i = errors.length - 1; i >= 0; i--) {
          console.warn('['+this.name+'] - onSubmitFail error: "' + errors[i] + '"');
        }
      }
      this.settings.onSubmitFail();
    },
    onFormSubmit: function(e) {
      e.preventDefault();
      var _this = this;

      $.ajax({
          async: true,
          crossDomain: true,
          url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          method: "POST",
          headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          data: {
              "g": this.settings.listId,
              "$fields": "$source",
              "email": this.$input.val(),
              "$source": this.settings.source
          },
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(jqXHR, textStatus) {        
          var errors = [];
          if(jqXHR.responseJSON.hasOwnProperty('errors')) {
            errors = jqXHR.responseJSON.errors;
          }

          _this.onSubmitFail(errors);
        });

      return false;
    }
  });

  return AjaxKlaviyoForm;
})(jQuery)

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.productDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {};

  var classes = {};

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.settings = {};
    this.name = 'product';
    this.namespace = '.'+this.name;

    var productDetailForm = new slate.ProductDetailForm({
      $el: this.$container,
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      enableZoom: this.$container.data('zoom-enabled') || false
    });

    productDetailForm.initialize();
    
    _this = this;
    this.$container = $(container);
    
    $(selectors.container).on('click', selectors.expandItemIcon, this.toggleQuestion.bind(this));
    $(selectors.container).on('click', selectors.expandItemMobileIcon, this.toggleMobileQuestion.bind(this));
    $(selectors.container).on('click', selectors.faqTab, this.toggleCategory.bind(this));
    $(selectors.container).on('click', selectors.faqSubTab, this.toggleSubCategory.bind(this));
    $(selectors.container).on('change', selectors.mobileSelect, this.toggleMobileCategory.bind(this));

  };
  
  var $window = $(window);

  var selectors = {
    'container': '[data-faqs-container]',
    'expandItemIcon': '[data-faq-expand]',
    'expandItemMobileIcon': '[data-faq-mobile-expand]',
    'faqContent': '[data-faq-content]',
    'faqMobileContent': '[data-faq-mobile-content]',
    'faqTab': '[data-faq-tab]',
    'faqSubTab': '[data-faq-subtab]',
    'target': '.faqs-category__items',
    'faqTabItem': '.faqs__tabs-item',
    'subcategoryTarget': '[data-subcategory-target]',
    'subcategoryContainer': '.faqs-subcategory__container',
    'catplusIcon': '.faq-category.mini-plus-icon',
    'plusIcon': '.mini-plus-icon',
    'mobileSelect': '[data-mobile-faq-select]'
  };


  Product.prototype = $.extend({}, Product.prototype, {
    
    toggleQuestion: function (e) {
      $(e.currentTarget).find(selectors.plusIcon).toggleClass('opened');
      $(e.currentTarget).find('.faqs-category__question').toggleClass('opened');
      $(e.currentTarget).parent().find(selectors.faqContent).slideToggle();
    },
    
    toggleMobileQuestion: function (e) {
      $(e.currentTarget).find(selectors.catplusIcon).toggleClass('opened');
      $(e.currentTarget).find('.faqs-category__question').toggleClass('opened');
      $(e.currentTarget).parent().find(selectors.faqMobileContent).slideToggle();
    },

    toggleMobileCategory: function (e) {
      e.preventDefault();
      var target = $(e.currentTarget).val();
      this._activateTab(e.currentTarget, target)
    },

    toggleCategory: function (e) {
      e.preventDefault();
      var target = $(e.currentTarget).data('category-target');
      this._activateTab(e.currentTarget, target)
    },

    toggleSubCategory: function (e) {
      var target = $(e.currentTarget).data('subcategory-target');
      var parentTarget = $(e.currentTarget).data('category-target');
      var parentTab = $(e.currentTarget).parent().parent().parent().find(selectors.faqTab);
      var headerHeight = 144;
      this._activateTab(parentTab, parentTarget);

      //scroll to subcategory
      $('html, body').animate({
          scrollTop: $(selectors.subcategoryContainer + '[data-subcategory="'+ target +'"]').offset().top - headerHeight
      }, 1000);
    },

    _activateTab: function(element, target) {
      //set underline
      $(selectors.faqTabItem).removeClass('active');
      $(element).parent().addClass('active');
      $(".tabTitle").html($(element).html());
      
      if ($(element).html()=="Our Products"){
        $(".faqs_tabs--sub").show();
      } else{
        $(".faqs_tabs--sub").hide();
      }

      //show content
      $(selectors.target).hide();
      $(selectors.target + '[data-category="'+ target +'"]').fadeIn();
    } 

  });

  return Product;
})(jQuery, slate);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.Collection = (function(slate) {

  var selectors = {
    collectionJson: '[data-collection-json]',
    collectionCategoryFilter: '[data-collection-category-filter]'
  };

  var classes = {

  };

  function Collection(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.name = 'collection';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      console.warn('['+this.name+'] - Element matching ' + selectors.collectionJson + ' required.')
      return;
    }

    this.collectionData = JSON.parse($(selectors.collectionJson, this.$container).html());

    this.filters = new slate.collectionFilters( container, this.collectionData );
    this.sort    = new slate.collectionSort( container, this.collectionData );

    $(selectors.collectionCategoryFilter, this.$container).on('change', this.onCollectionCategoryFilterChange.bind(this));
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    onCollectionCategoryFilterChange: function(e) {
      var $select = $(e.currentTarget);
      window.location.href = $select.find('option:selected').val();
    }
  });

  return Collection;

 })(slate)

/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - pencilBanner
 */

theme.PencilBanner = (function($) {

  var $window = $(window);

  var selectors = {
    close: '[data-pencil-banner-close]'
  };

  var classes = {

  };

  /**
   * Pencil Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function PencilBanner(container) {
    this.$container = $(container);

    this.name = 'pencilBanner',
    this.namespace = '.'+this.name;

    this.events = {
      SHOW: 'show'   + this.namespace,
      CLOSE: 'close' + this.namespace
    };

    $(selectors.close).on('click', this.close.bind(this));
  }

  PencilBanner.prototype = $.extend({}, PencilBanner.prototype, {

    /**
     * Allows you to run specific code when viewing this section inside the theme editor for a more pleasant experience
     * To use, call this at the end of the constructor method
     */
    initForThemeEditor: function() {
     
      if(slate.utils.isThemeEditor()){
        // Hide the close button to make life simpler
        // $(selectors.close).hide();
      }
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to show the banner
     */
    show: function() {
     // console.log('['+this.name+'] - open');
      $window.trigger( $.Event(this.events.SHOW) );
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to close the banner
     */
    close: function() {
     // console.log('['+this.name+'] - close');
      $window.trigger( $.Event(this.events.CLOSE) );
    },

    onCloseClick: function(e){
      e.preventDefault();
      this.close();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
    //  console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
    //  console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
     // console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
     // console.log('['+this.name+'] - section::unload');
    }
  });

  return PencilBanner;
})(jQuery);

/**
 * Subscription Modal Section Script
 * ------------------------------------------------------------------------------
 * 
 
 updated for CF-14: Email Signup Lightbox for New Visitors
 	- note: Subscription modal is tied to Klaviyo
 
 {RWC} - this modal and prototype object has been updated to integrate with SFMC. Some 
 			functionality from the 'Subscription Slideup' and 'Ajax Klaviyo Form' has been
            rolled into this one. To bring back previous functionality for this please 
            see a previous version of the theme. 
 
 * Requires:
 *  - slate.utils
 *  - slate.user
 *  - $.modal (bootstrap modal)
 *
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - subscriptionModal
 */

theme.SubscriptionModal = (function($, slate) {

  var selectors = {
    modal: '.modal.subscription-modal', 
    formWrapper: '[data-subscription-modal]',
    form: '[data-subscription-modal-form]',
    menuItem: 'a[href="/pages/email-signup-page"]',
    emailInput: '[data-subscription-modal-form] input[type="email"]',
    successMessage: '[data-subscription-modal-success]',
    formMessage: '[data-subscription-form-message]',
    formContent: '[data-subscription-form-content]',
    shpfyElmt: '#shopify-section-subscription-modal-sfmc'
  };

  var classes = {
    showMessage: "sfmc-submit--show-message"
  };

  /**
   * Subscription Modal section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SubscriptionModal(container) {
    this.$formWrapper = $(selectors.formWrapper);
    this.$form = $(selectors.form);
    this.$container = $(container);
    this.$menuItem = $(selectors.menuItem);

    this.$input   = this.$form.find('input[type="email"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.$loggedInUser = this.$container.data('logged-in-user');
    
    this.name = 'subscriptionModal';
    this.namespace = '.'+this.name;

    this.settings = {
      source: "Shopify Email Signup Modal",
      //sfmcEndpoint: "https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
      //klaviyoEndpoint: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      //sfmcList: this.$container.data('sfmc-list'),
      disablePages: this.$container.data('disable-pages').split(','),
      enabled        : this.$container.data('enabled'),
      delay          : !isNaN(parseInt( this.$container.data('delay'))) ? (parseInt( this.$container.data('delay'))*1000) : 3000, // delay before showing the modal on pageload,
      seenExpiration : !isNaN(parseInt( this.$container.data('seen-expiration'))) ? parseInt( this.$container.data('seen-expiration')) : 30 // days before showing the modal again
    };

    // if seenExpiration is set to 0, set it to 1 year (very far into the future)
    if(this.settings.seenExpiration == 0) {
      this.settings.seenExpiration = 365;
    }    

    /**
     * These are the cookies that we'll use to keep track of how much the user has seen / interacted with the popup
     */
    this.cookies = {}

    this.cookies.seen = {};
    this.cookies.seen.name = '_subscriptionModal_seen';
    this.cookies.seen.value = slate.utils.hashFromString($(selectors.modal).text()).toString(); // Set the cookie value based on the content
    this.cookies.seen.expiration = this.settings.seenExpiration;

    this.cookies.emailCollected = {};
    this.cookies.emailCollected.name = '_subscriptionModal_emailCollected';
    this.cookies.emailCollected.value = true;
    this.cookies.emailCollected.expiration = this.settings.seenExpiration;

    this.$modal = $(selectors.modal, this.$container);

    /**
     * Attach event handlers
     */
    this.$modal.on('shown.bs.modal', this.onShown.bind(this));
    this.$modal.on('hidden.bs.modal', this.onHidden.bind(this));
    $(selectors.form, this.$modal).on('submit', this.onFormSubmit.bind(this));

    /* CF-60 - if modal is not on screen it is labelled hidden */
    if ($(selectors.shpfyElmt).length > 0) { 
      $(selectors.shpfyElmt).removeAttr('aria-hidden').attr('aria-hidden','true'); 
      slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'hide');
    }
    
    /**
     * Checks the show logic and displays the popup if everything checks out
     * Note: we are defined if modal should be show using our logic AND embeded Klaviyo modal logic!
     * so first should wait for loading of Klaviyo embeded modal
     */
    if(this.shouldShow()) {
      setTimeout(this.show.bind(this), this.settings.delay);
    } else {
      this.$formWrapper.hide();
      this.$menuItem.hide();
    }

  }

  SubscriptionModal.prototype = $.extend({}, SubscriptionModal.prototype, {

    /*** MODAL ACTIONS ***/
    
    onCloseClick: function(e){
      e.preventDefault();
      this.hide();
    },

// RWC: not sure if the 2 blocks below are needed for Klaviyo modal
//     onFormSubmit: function(e) {
//       /**
//        * STUB METHOD - You need to add implementation details
//        */
//       e.preventDefault();
//     //  console.log('['+this.name+'] - onFormSubmit');
//     },

//     onFormSuccess: function() {
//       $(selectors.form, this.$modal).hide();
//       $(selectors.successMessage, this.$modal).show();
//       // setTimeout => this.hide() ?
//     },
    
    hide: function() {
      this.$modal.modal('hide');
      /* {RWC} removed for now - if user closes modal do NOT set seen cookie
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }   
      */
    },

    show: function() {
      this.$modal.modal('show');
    },

    shouldShow: function() {

      // Checks should be done in this order!

      if(slate.utils.isThemeEditor() || !this.settings.enabled) {
        return false;
      }

      if(slate.user.hasCookie(this.cookies.emailCollected.name)) {
        return false;
      }      

      if( slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
        return false
      }

      return true;
    },

    onShown: function() {
      /* CF-60 - if modal is on screen */
      if ($(selectors.shpfyElmt).length > 0) { 
        $(selectors.shpfyElmt).removeAttr('aria-hidden').attr('aria-hidden','false'); 
        slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'show');
      }
      
      // $(selectors.emailInput).focus();
    },

    onHidden: function() {
      /* CF-60 - if modal is not on screen it is labelled hidden */
      if ($(selectors.shpfyElmt).length > 0) { 
        $(selectors.shpfyElmt).removeAttr('aria-hidden').attr('aria-hidden','true'); 
        slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'hide');
      }
      
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.show();
    },

    onDeselect: function() {
      this.hide();
    },
    
    /*** SHOW MODAL CHECKS ***/

    shouldShow: function() {

      if(slate.utils.isThemeEditor() || !this.settings.enabled) {
        return false;
      }

      // Checks should be done in this order!

      /* 
      CF-14 - when the user should see modal:

        Use Case: When a new user comes to the site they will receive a pop up modal on 
        	first page visit (time tbc for pop up â€“ 5 seconds?)

		{RWC} this is set in the data attrib on the modal - see `subscription-modal-sfmc.liquid`

		Use Case: When an unregistered user comes to the site any subsequent time after 
        	their first visit times and they have NOT signed up to receive the newsletter, 
            they will still receive the email pop up and see the overlay widget. 

		Use Case: When an unregistered user comes to the site after an earlier visit where 
        	they had signed up to receive the newsletter, they wonâ€™t see the email pop 
            up OR the on page sign up widget. 
			-	IF this is not possible:
				o	When an unregistered user comes to the site after an earlier visit where 
                they had signed up to receive the newsletter, if they register for the newsletter 
                again the modal will provide a response confirming they have already 
                signed up for the newsletter (actual copy TBC â€“ the modal should validate 
                against Klaviyo that the email already exists)

		Use Case: When an user registers in the checkout flow, the newsletter email 
        	will NOT be triggered to send.  

        Use Case: user is on page where form SHOULD NOT be shown. Pages:
            - account login
            - forgot password
            - checkout


      ---

     */

      // test the page which user is on
      for(var p of this.settings.disablePages) {
        if (slate.utils.isOnPage(p)) {
          console.debug('-- DEBUG: skipping subscription modal - disabled on page: '+p);
          return false;
        }
      }

      //       if(slate.user.hasCookie(this.cookies.emailCollected.name)) {
      //         return false;
      //       }

      // test if logged in user is on list
      if (this.$loggedInUser) {
        //if(slate.utils.subscribedToList(this.settings.sfmcList, this.$loggedInUser)) {
        return false;
        //}
      }

      //       if(slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
      //         return false
      //       }

      return true;
    },


  });

  return SubscriptionModal;
})(jQuery, slate);

/**
 * Instagram Feed Section Script
 * ------------------------------------------------------------------------------
 *
 * Uses Instafeed.js to interact with Instagram API
 *   - See instafeedjs.com for documentation
 *   - See scripts/vendor directory for source file
 *
 * @namespace - instagramFeed
 */

theme.instagram = {
        init: function() {
          var _section_get_id = $(".globo-instagram");
          var section_id = _section_get_id.data('id');

          var g_instagram_option = {
            get: 'user',
            userId: 'self',
            resolution: 'low_resolution'
          };
          var g_instagram_template = '<div class="grid-item"><div class="instagram-item"><a target="_blank" href="\{\{link\}\}" title="\{\{caption\}\}" style="background-image: url(\{\{image\}\});" class="thumbnail"><img src="\{\{image\}\}" alt="\{\{caption\}\}"></a><div class="instagram-info"><span class="instagram-like"><i class="fa-heart"></i>\{\{likes\}\}</span><span class="instagram-comments"><i class="fa-comments"></i>\{\{comments\}\}</span></div></div></div>';
          var g_token_input = document.querySelector('#g-token-' + section_id);
          if (!g_token_input) {
            return;
          }
          var g_token = g_token_input.value;
          var g_target = document.querySelector('#g-instafeed-' + section_id);
          var limit = parseInt(g_target.dataset.limit);
          var sortBy = g_target.dataset.sortBy;
          var options = $.extend({}, {
            limit: limit,
            target: g_target,
            accessToken: g_token,
            sortBy: sortBy,
            template: g_instagram_template,
            after: function () {
              $('.g-instafeed-slick-' + section_id).slick();
            },
            error: function (message) {
              console.error("Error: " + message);
            }
          }, g_instagram_option);
          var g_feed = new Instafeed(options);
          g_feed.run();
        }        
    };

theme.InstagramFeed = (function($, slate, Instafeed) {
          var _section_get_id = $(".globo-instagram");
          var section_id = _section_get_id.data('id');

          var g_instagram_option = {
            get: 'user',
            userId: 'self',
            resolution: 'low_resolution'
          };
          var g_instagram_template = '<div class="grid-item"><div class="instagram-item"><a target="_blank" href="\{\{link\}\}" title="\{\{caption\}\}" style="background-image: url(\{\{image\}\});" class="thumbnail"><img src="\{\{image\}\}" alt="\{\{caption\}\}"></a><div class="instagram-info"><span class="instagram-like"><i class="fa-heart"></i>\{\{likes\}\}</span><span class="instagram-comments"><i class="fa-comments"></i>\{\{comments\}\}</span></div></div></div>';
          var g_token_input = document.querySelector('#g-token-' + section_id);
          if (!g_token_input) {
            return;
          }
          var g_token = g_token_input.value;
          var g_target = document.querySelector('#g-instafeed-' + section_id);
          var limit = parseInt(g_target.dataset.limit);
          var sortBy = g_target.dataset.sortBy;
          var options = $.extend({}, {
            limit: limit,
            target: g_target,
            accessToken: g_token,
            sortBy: sortBy,
            template: g_instagram_template,
            after: function () {
              $('.g-instafeed-slick-' + section_id).slick();
            },
            error: function (message) {
              console.error("Error: " + message);
            }
          }, g_instagram_option);
          var g_feed = new Instafeed(options);
          g_feed.run();
        
})(jQuery, slate, Instafeed);

/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slideshow
 */

theme.Slideshow = (function($) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

  var classes = {

  };

  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    if( !$(selectors.slideshowWrapper, this.$container).length ){
      console.warn('['+this.name+'] - Element matching '+selectors.slideshowWrapper+' required to initialize');
      return;
    }

   this.$slideshow = $(selectors.slideshow, this.$container);

   var enableSliderDots     = this.$slideshow.data('dots') || false;
   var enableSliderControls = this.$slideshow.data('controls') || false;

    var settings = {
      dots: this.$slideshow.children().length == 1 ? false : enableSliderDots, // no dots if we have one slide
      arrows: enableSliderControls
    };

    this.slideshow = new slate.Slideshow( $(selectors.slideshowWrapper, this.$container), settings);

  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return Slideshow;
})(jQuery);

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - header
 */

theme.Header = (function($) {

  var $window = $(window);
  var $pencilBanner = $('[data-pencil-banner]'); // Technically this section shouldn't be aware of the pencil banner section but I think it's okay for now...

  var selectors = {
    dropdownTrigger: '[data-dropdown-trigger][data-block]',
    header: '[data-header]',
    search: '[data-search]',
    searchOpen: '[data-search-open]',
    searchClose: '[data-search-close]',
    searchInput: '[data-search-input]'
  };

  var classes = {
    dropdownOpen: 'is-open',
    headerActive: 'is-active',
    headerFixed: 'is-fixed',
    searchActive: 'is-active'
  };

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element matching selectors.dropdownTrigger
   */
  function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el = $( this.$trigger.data('dropdown-trigger') );
    this.blockId = this.$trigger.data('block').toString();
  };

  Dropdown.prototype = {
    
    /* START CF-60 adding aria states to menu items */
    /* todo:
    	- dropdown menu is not staying open when the next link is tabbed to, can do with CF-63
    */
    
    isOpen: function() {
      return this.$el.hasClass( classes.dropdownOpen );
    },
    open: function() {
//       console.debug('~~ dd fire open');
      this.$el.addClass( classes.dropdownOpen );    
      this.$el.attr('aria-expanded',true);
      this.$el.find('.dd-menu-item').attr('aria-hidden',false).attr('tabindex',0);
    },
    close: function() {      
//       console.debug('~~ dd fire close');
      this.$el.removeClass( classes.dropdownOpen );      
      this.$el.attr('aria-expanded',false);
      this.$el.find('.dd-menu-item').attr('aria-hidden',true).attr('tabindex',-1);
    }
    
    /* END CF-60 adding aria states to menu items */
    
  };

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function DropdownManager() {

    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 80;
    this.dropdowns = [];
    this.activeDropdown = undefined;

    var events = window.PointerEvent ? {
                  end:   "pointerup",
                  enter: "pointerenter focusin",
                  leave: "pointerleave focusout"
                } : {
                  end: "touchend",
                  enter: "mouseenter focusin",
                  leave: "mouseleave focusout"
                };

    this.register = function($trigger) {
      var dd = new Dropdown($trigger);
      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(events.enter,  this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(events.leave,  this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(events.end,    this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(events.end,   this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);
    };

  };

  /* CF-60 fixed triggering of menu triggers and sub-item selection 
  		- look to the next target, if it is menu-item then stay open
  */ 
  
  DropdownManager.prototype = {
    getDropdownByBlockId: function(id) {
      return slate.utils.findInstance(this.dropdowns, 'blockId', id);
    },
    onTriggerMouseEnter: function(dd, e) {
      console.debug('~~ dd MouseEnter trigger');
      dd.$trigger.addClass('dd-trigger-active');
      dd.$el.addClass('dd-trigger-active-dd'); 
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },
    onTriggerMouseLeave: function(dd, e) {
      if (dd.$el.hasClass('is-open') && $(e.relatedTarget).hasClass('dd-menu-item')) {
        console.debug('~~ dd MouseLeave trigger - stay open, next target is menu item');
      } else {
        console.debug('~~ dd MouseLeave trigger - close');
        dd.$trigger.removeClass('dd-trigger-active');
        dd.$el.removeClass('dd-trigger-active-dd'); 
        if(e.pointerType != "touch") {
          this.startCloseTimeout(dd);
        }
      }
    },
    onTriggerTouchEnd: function(dd, e) {
      console.debug('~~ dd TouchEnd trigger');
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },
    onDropdownMouseEnter: function(dd, e) {
      console.debug('~~ dd MouseEnter dropdown');
      dd.$el.addClass('is-open');
      dd.$el.addClass('dd-is-active');
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },
    onDropdownMouseLeave: function(dd, e) {
      if (dd.$el.hasClass('is-open') && $(e.relatedTarget).hasClass('dd-menu-item')) {
        console.debug('~~ dd MouseLeave dropdown item - stay open, next target is menu item');
      } else {
        console.debug('~~ dd MouseLeave dropdown item - close');
        dd.$el.removeClass('dd-is-active');
        if(e.pointerType != "touch") {
          this.startCloseTimeout(dd);
        }
      }
    },
    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },
    toggleDropdown: function(dd) {
      console.debug('~~ dd fire toggleDropdown');
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },
    openDropdown: function(dd) {
      console.debug('~~ dd fire openDropdown');
      dd.$el.find('.dd-menu-item').attr('aria-hidden',false).attr('tabindex',0);
      if(this.activeDropdown !== dd) {
        this.activeDropdown = dd;
        // this.closeAllDropdowns();
        dd.open();
      }
    },
    closeDropdown: function(dd) {
      console.debug('~~ dd fire closeDropdown');
      dd.close();
      if(this.activeDropdown == dd) {
        this.activeDropdown = undefined;
      }
    },
    closeAllDropdowns: function() {
      console.debug('~~ dd fire closeAllDropdowns');
      $.each(this.dropdowns, function(i, dd) {
        if(dd.isOpen()) {
          dd.close();
        }
      });
      this.activeDropdown = undefined;
    },
    startCloseTimeout: function(dd) {
      console.debug('~~ dd fire startCloseTimeout');
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },
    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    }
  };

  function Header(container) {

    var _this = this;

    this.$container = $(container);
    this.$el = $(selectors.header, this.$container);
    this.name = 'header';
    this.namespace = '.'+this.name;
    this.dropdownManager = new DropdownManager();

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    // Construct a new dropdown from each trigger and add to our array of dropdowns to keep track
    $(selectors.dropdownTrigger).each(function(i, trigger) {
      _this.dropdownManager.register( $(trigger) );
    });

    this.$container.on('pointerenter mouseenter focusin', this.onMouseEnter.bind(this));
    this.$container.on('pointerleave mouseleave focusout', this.onMouseLeave.bind(this));
    this.$container.on('keydown', selectors.search, this.onSearchKeyDown.bind(this));
    this.$container.on('click',   selectors.searchOpen, this.onSearchOpenClick.bind(this));
    this.$container.on('click',   selectors.searchClose, this.onSearchCloseClick.bind(this));

    if($pencilBanner.length && !$pencilBanner.is(':hidden')){
      $window.on(this.events.SCROLL, $.throttle(20, requestAnimationFrame.bind(window, this.onScroll.bind(this)))); // throttle + rAF = smooth scrolling :)
      this.onScroll(); // hit this one time on init to make sure everything is good
    }
    else {
      // this.$el.addClass( classes.headerFixed );
    }

  };

  Header.prototype = $.extend({}, Header.prototype, {

    // Scroll stuff to make sure the ticker + header work correctly together
    scrollCheck: function() {
      var $pb = $pencilBanner;

      if(slate.utils.isThemeEditor()) {
        // The theme editor screws screws up the $ticker variable outside of this scope when we load / unload the section
        // so we have to reset it here
        // only do it if we're in the theme editor though to avoid dom lookups on the user facing site.
        $pb = $('.pencil-banner');
      }

      // If ticker is there, visible, and we haven't scrolled past it...
      if($pb && $pb.get(0).style.display !== "none" && $window.scrollTop() < $pb.outerHeight()){
        this.$el.removeClass( classes.headerFixed );
      }
      else {
        this.$el.addClass( classes.headerFixed );
      }
    },

    onScroll: function() {
      this.scrollCheck();
    },

    onMouseEnter: function() {
      this.$el.addClass(classes.headerActive);
    },

    onMouseLeave: function() {
      console.debug('~~ dd fire Header onMouseLeave - not calling closeAllDropdowns');
      //this.dropdownManager.closeAllDropdowns();
      this.$el.removeClass(classes.headerActive);
    },

    onSearchKeyDown: function(e) {
      if(e.which == 27) { // esc key
        this.closeSearch();
        // return focus?
      }
    },

    onSearchOpenClick: function(e) {
      e.preventDefault();
      this.openSearch();
    },

    onSearchCloseClick: function(e) {
      e.preventDefault();
      this.closeSearch();
    },

    openSearch: function() {
//       console.debug('~~ open search');
      $(selectors.search, this.$container).addClass(classes.searchActive);
      $(selectors.searchInput, this.$container).first().focus();
    },

    closeSearch: function() {
//       console.debug('~~ close search');
      $(selectors.search, this.$container).removeClass(classes.searchActive);
    },

    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(e) {
      var blockId  = e.detail.blockId;
      var dropdown = this.dropdownManager.getDropdownByBlockId(blockId);

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.open();
      }
    },

    onBlockDeselect: function(e) {
      var blockId  = e.detail.blockId;
      var dropdown = this.dropdownManager.getDropdownByBlockId(blockId);

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.close();
      }
    }
  });

  return Header;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($) {

  var $window = $(window);

  var selectors = {
    'expandItem': '.footer--nav-label',
    'menuList': '.footer--nav',
    'plusIcon': '.footer--nav-expand.plus-icon',
    'isMobile': '.is-mobile'
  };

  function Footer(container) {

    _this = this;
    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;
    
    $('.footer--col').on('click', selectors.expandItem, function (e) {
 
      /* start CF-60 ensure that ARIA state for links is updated */
      
      var $plus = $(this).find('.plus-icon');  
      $plus.toggleClass('opened');
            
      var $nav = $(this).parent().find(selectors.menuList);
      $nav.slideToggle(); 

      if ($plus.hasClass('opened')) {
        $plus.attr('aria-expanded', true);
        slate.a11y.toggleHiddenFocus($nav, 'show');
        slate.a11y.toggleARIAHidden($nav, 'show');
      } else {
        $plus.attr('aria-expanded', false);
        slate.a11y.toggleHiddenFocus($nav, 'hide');
        slate.a11y.toggleARIAHidden($nav, 'hide');
      }
      
        $("html, body").animate({ scrollTop: $(document).height() }, "slow");
      
     
      
        return false;
      
      /* end CF-60 ensure that ARIA state for links is updated */
      
    });
  };

  return Footer;
})(jQuery);

/**
 * Ajax Cart Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the interacting with the ajax cart section.
 * All logic is handled in slate.AjaxCart, this file is strictly for handling section settings and them editor interactions
 *
 * @namespace - ajaxCart
 */

theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
    this.namespace = '.'+this.name;

    this.ajaxCart = new slate.AjaxCart();

    if (!$body.hasClass('template-cart')) {
      this.ajaxCart.init();      
    }
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onShow: function() {

    },

    onLoad: function() {

    },

    onUnload: function() {

    }
  });

  return AjaxCart;
})(jQuery);

/**
 * Cart Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - cart
 */

theme.Cart = (function($) {

  var $window = $(window);

  var selectors = {
    form: '[data-cart-form]',
    itemQtySelect: '[data-item-quantity-select]'
  };

  var classes = {

  };

  function Cart(container) {

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

    var $form = $(selectors.form, this.$container); 

    // Since we have more than 1 quantity select per row (1 for mobile, 1 for desktop)
    // We need to use single input per row, which is responsible for sending the form data for that line item
    // Watch for changes on the quantity selects, and then update the input.  These two are tied together using a data attribute
    $(selectors.itemQtySelect).on("input", function(){
     //console.log("test");
      var $itemQtyInput = $('[id="' + $(this).data('item-quantity-select') + '"]'); // Have to do '[id=".."]' instead of '#id' because id is generated using {{ item.key }} which has semi-colons in it - breaks normal id select
      $itemQtyInput.val($(this).val());  
      $form.submit(); 
    });    

  };

  Cart.prototype = $.extend({}, Cart.prototype, {

  });

  return Cart;
})(jQuery);

theme.RelatedProducts = (function($, slate) {

  var selectors = {
    container: '[data-related-products-container]'
  };

  var $window = $(window);

  function RelatedProducts(container) {
    this.$container = $(container);

    this.name = 'relatedProducts';
    this.namespace = '.'+this.name;

    events = {
      RESIZE: 'resize'  + this.namespace,
      LOAD: 'load' + this.namespace
    };

    this.slideshowBpMin = slate.breakpoints.getBreakpointMinWidth('md');

    $(selectors.container).slick({
      arrows: false,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: (this.slideshowBpMin - 1),
          settings: {
            slidesToShow: 2,
            centerMode: true,
            infinite: true
          }
        }
      ]
    });
  }

  RelatedProducts.prototype = $.extend({}, RelatedProducts.prototype, {});

  return RelatedProducts;
})(jQuery, slate);

/**
 * Subscription Slideup Section Script
 * ------------------------------------------------------------------------------
 * 
 * This implementation is incomplete, there are empty methods that need to be wired up and filled in.
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - subscriptionSlideup
 */

theme.SubscriptionSlideUp = (function($, slate) {

  var selectors = {
    slideUp: '[data-subscription-slideup]',
    klaviyoForm: 'form[data-klaviyo-slideup-list-id]',
    close: '[data-subscription-slideup-close]',
    formContent: '[data-subscription-slideup-form-content]',
    formMessage: '[data-subscription-slideup-form-message]',
    shpfyElmt: '#shopify-section-subscription-slideup'
  };

  var classes = {
    slideUpVisible: 'is-visible',
    showMessage: 'show-message'
  };

  /**
   * Subscription Slideup section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SubscriptionSlideUp(container) {
    this.$container = $(container);

    this.name = 'subscriptionSlideUp';
    this.namespace = '.'+this.name;

    var enabled        = this.$container.data('enabled');
    var delay          = !isNaN(parseInt( this.$container.data('delay'))) ? (parseInt( this.$container.data('delay'))*1000) : 3000;
    var seenExpiration = !isNaN(parseInt( this.$container.data('seen-expiration'))) ? parseInt( this.$container.data('seen-expiration')) : 30;

    // if seenExpiration is set to 0, set it to 1 year (very far into the future)  See section settings schema.
    if(seenExpiration == 0) {
      seenExpiration = 365;
    }

    this.settings = {
      enabled        : enabled, // turn this functionality on / off
      delay          : delay, // delay before showing the popup on pageload,
      seenExpiration : seenExpiration // days before showing the popup again
    };

    /**
     * These are the cookies that we'll use to keep track of how much the user has seen / interacted with the popup
     */
    this.cookies = {}

    this.cookies.seen = slate.user.createCookie('subscriptionSlideUpSeen');
    this.cookies.seen.value = slate.utils.hashFromString($(selectors.slideUp).text()).toString(); // Set the cookie value based on the content
    this.cookies.seen.expiration = seenExpiration;

    this.cookies.emailCollected = slate.user.createCookie('emailCollected');
    this.cookies.emailCollected.expiration = seenExpiration;

    this.$slideUp     = $(selectors.slideUp, this.$container);
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);
    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);

    this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
      listId: this.$klaviyoForm.data('klaviyo-slideup-list-id'),
      source: this.$klaviyoForm.data('klaviyo-source'),
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
      onSubmitFail: this.onSubmitFail.bind(this)
    });    

    /**
     * Attach event handlers
     */
    this.$container.on('click', selectors.close, this.onCloseClick.bind(this));

    /* CF-60 - if modal is not on screen it is labelled hidden */
    if ($().length > 0) { 
      $(selectors.shpfyElmt).removeAttr('aria-hidden').attr('aria-hidden','true'); 
      slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'hide');
    }
    
    /**
     * Checks the show logic and displays the popup if everything checks out
     */
    if(this.shouldShow()) {
      setTimeout(this.show.bind(this), this.settings.delay);
    }

  }

  SubscriptionSlideUp.prototype = $.extend({}, SubscriptionSlideUp.prototype, {

    /**
     * Resets everything to it's initial state.  Only call when slideup isn't visible.
     */
    reset: function() {
      this.$formContent.find('input[type="email"]').val('');
      this.$formMessage.html('');
      this.$formContent.removeClass(classes.showMessage);
    },

    onSubscribeSuccess: function() {
      this.$formMessage.html( this.$formMessage.data('message-success') );
      this.$formContent.addClass(classes.showMessage);
      
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }      
    },

    onSubmitFail: function() {
      this.$formMessage.html( this.$formMessage.data('message-fail') );     
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function(){
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onCloseClick: function(e){
      e.preventDefault();
      this.hide();
    },

    hide: function() {
      /* CF-60 - if modal is not on screen it is labelled hidden */
      if ($(selectors.shpfyElmt).length > 0) { 
        $(selectors.shpfyElmt).removeAttr('aria-hidden').attr('aria-hidden','true'); 
        slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'hide');
      }
      
      this.$slideUp.removeClass(classes.slideUpVisible);
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }

      // Reset the form after the hide animation completes
      this.$slideUp.one(slate.utils.whichTransitionEnd(), this.reset.bind(this));
    },

    show: function() {
      /* CF-60 - if modal is on screen */
      if ($(selectors.shpfyElmt).length > 0) { 
        $(selectors.shpfyElmt).removeAttr('aria-hidden').attr('aria-hidden','false'); 
        slate.a11y.toggleHiddenFocus(selectors.shpfyElmt, 'show');
      }
      
      this.$slideUp.addClass(classes.slideUpVisible);
    },

    shouldShow: function() {

      // Checks should be done in this order!

      if(slate.utils.isThemeEditor() || !this.settings.enabled) {
        return false;
      }

      if(slate.user.hasCookie(this.cookies.emailCollected.name)) {
        return false;
      }

      if( slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
        return false
      }

      return true;
    },

    onHidden: function() {
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.show();
    },

    onDeselect: function() {
      this.hide();
    }
  });

  return SubscriptionSlideUp;
})(jQuery, slate);

/**
 * Press Blocks Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - press-blocks
 */

theme.PressBlocks = (function($) {

  var $window = $(window);

  var selectors = {
    'loadMoreButton': '[data-load-button]',
    'pressItem': '[data-press-item]',
    'hiddenPressItem': '[data-press-item]:hidden'
  };

  function PressBlocks(container) {
    //console.log("Initializing PressBlocks");
    _this = this;
    this.$container = $(container);
    this.perPage = pb_items_per_page; //global variable set in sections/press-blocks.liquid
    this.loadMore();
    $(this.$container).on('click', selectors.loadMoreButton, this.loadMoreClick.bind(this));
  };

  PressBlocks.prototype = $.extend({}, PressBlocks.prototype, {
    
    loadMoreClick: function(e) {
      e.preventDefault();
      this.loadMore();
    },

    loadMore: function() {
      //console.log($(selectors.hiddenPressItem));
      $(selectors.hiddenPressItem).slice(0, this.perPage).fadeIn();
      //console.log($(selectors.hiddenPressItem).slice(0, this.perPage));
      if ($(selectors.hiddenPressItem).length == 0) {
          $(selectors.loadMoreButton).fadeOut('slow');
      }
    }

  });

  return PressBlocks;
})(jQuery);

/**
 * FAQs Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - faqs
 */

theme.FAQs = (function($) {
  
  $(document).ready(function() {
    // document is loaded and DOM is ready
    if ($(window).width() > "972"){
        $(".faq__tab__desktop").show();
        $(".faq__tab__mobile").hide();
    }
    else{
       $(".faq__tab__desktop").hide();
        $(".faq__tab__mobile").show();
    }
  });
  
  $(window).resize(function() {
   if ($(window).width() > "972"){
        $(".faq__tab__desktop").show();
        $(".faq__tab__mobile").hide();
    }
    else{
       $(".faq__tab__desktop").hide();
        $(".faq__tab__mobile").show();
    }
  });

  var $window = $(window);

  var selectors = {
    'container': '[data-faqs-container]',
    'expandItemIcon': '[data-faq-expand]',
    'expandItemMobileIcon': '[data-faq-mobile-expand]',
    'faqContent': '[data-faq-content]',
    'faqMobileContent': '[data-faq-mobile-content]',
    'faqTab': '[data-faq-tab]',
    'faqSubTab': '[data-faq-subtab]',
    'target': '.faqs-category__items',
    'faqTabItem': '.faqs__tabs-item',
    'subcategoryTarget': '[data-subcategory-target]',
    'subcategoryContainer': '.faqs-subcategory__container',
    'catplusIcon': '.faq-category.mini-plus-icon',
    'plusIcon': '.mini-plus-icon',
    'mobileSelect': '[data-mobile-faq-select]'
  };

  function FAQs(container) {
    _this = this;
    this.$container = $(container);
    
    $(selectors.container).on('click', selectors.expandItemIcon, this.toggleQuestion.bind(this));
    $(selectors.container).on('click', selectors.expandItemMobileIcon, this.toggleMobileQuestion.bind(this));
    $(selectors.container).on('click', selectors.faqTab, this.toggleCategory.bind(this));
    $(selectors.container).on('click', selectors.faqSubTab, this.toggleSubCategory.bind(this));
    $(selectors.container).on('change', selectors.mobileSelect, this.toggleMobileCategory.bind(this));
  };

  FAQs.prototype = $.extend({}, FAQs.prototype, {
    
    toggleQuestion: function (e) {
      $(e.currentTarget).find(selectors.plusIcon).toggleClass('opened');
      $(e.currentTarget).find('.faqs-category__question').toggleClass('opened');
      $(e.currentTarget).parent().find(selectors.faqContent).slideToggle();
    },
    
    toggleMobileQuestion: function (e) {
      $(e.currentTarget).find(selectors.catplusIcon).toggleClass('opened');
      $(e.currentTarget).find('.faqs-category__question').toggleClass('opened');
      $(e.currentTarget).parent().find(selectors.faqMobileContent).slideToggle();
    },

    toggleMobileCategory: function (e) {
      e.preventDefault();
      var target = $(e.currentTarget).val();
      this._activateTab(e.currentTarget, target)
    },

    toggleCategory: function (e) {
      e.preventDefault();
      var target = $(e.currentTarget).data('category-target');
      this._activateTab(e.currentTarget, target)
    },

    toggleSubCategory: function (e) {
      var target = $(e.currentTarget).data('subcategory-target');
      var parentTarget = $(e.currentTarget).data('category-target');
      var parentTab = $(e.currentTarget).parent().parent().parent().find(selectors.faqTab);
      var headerHeight = 144;
      this._activateTab(parentTab, parentTarget);

      //scroll to subcategory
      $('html, body').animate({
          scrollTop: $(selectors.subcategoryContainer + '[data-subcategory="'+ target +'"]').offset().top - headerHeight
      }, 1000);
    },

    _activateTab: function(element, target) {
      //set underline
      $(selectors.faqTabItem).removeClass('active');
      $(element).parent().addClass('active');
      $(".tabTitle").html($(element).html());
      
      if ($(element).html()=="Our Products"){
        $(".faqs_tabs--sub").show();
      } else{
        $(".faqs_tabs--sub").hide();
      }

      //show content
      $(selectors.target).hide();
      $(selectors.target + '[data-category="'+ target +'"]').fadeIn();
    }   

  });

  return FAQs;
})(jQuery);

theme.FourUpMobileSlider = (function ($, slate) {

  var selectors = {
    sliderElement: '[data-slider-for-mobile]',
    slide: '[data-product-card]'
  }

  var $window = $(window);

  function FourUpMobileSlider(container) {
    this.$container = $(container);

    this.name = 'fourUpMobileSlider',
    this.namespace = '.'+this.name;

    this.slideshowBpMin = slate.breakpoints.getBreakpointMinWidth('md');

    $(selectors.sliderElement).slick({
      arrows: false,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      infinite: true,
      slide: selectors.slide,
      centerPadding: "80px",
      responsive: [
        {
          breakpoint: (this.slideshowBpMin - 1),
          settings: {
            centerMode: true,
            slidesToShow: 2
          }
        }
      ]
    });
  }

  FourUpMobileSlider.prototype = $.extend({}, FourUpMobileSlider.prototype, {});

  return FourUpMobileSlider;

})(jQuery, slate)

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]'
  };

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink', 
    hideAccountSignupLink: '#HideAccountSignupLink', 
    accountSignupLink: '#AccountSignup'
  };
  
  

  //if (!$(config.recoverPasswordForm).length) {
  //  return;
  //}
  
  //if (!$(config.accountSignupLink).length) {
  //  return;
  //}

  checkUrlHash();
  resetPasswordSuccess();
  
  //console.log("hello");


  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.accountSignupLink).on('click', onShowHideAccountSignupForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
  $(config.hideAccountSignupLink).on('click', onShowHideAccountSignupForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }
  
   function onShowHideAccountSignupForm(evt) {
    evt.preventDefault();
    toggleAccountSignupForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;
   
    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }    
    
     if (hash === '#signup') {
      toggleAccountSignupForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }
  
   /**
   *  Show/Hide Account Creation form
   */
  function toggleAccountSignupForm() {
    $('#CustomerLoginForm').toggleClass('hide');
    $('#AccountSignupForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

slate.search = (function(){
  
  var $document = $(document);
  var $body = $(document.body);

  var selectors = {
    openModalLink: '[data-js-search-modal-link]',
    closeModalLink: '[data-js-close-modal-link]',
    modalWindow: '[data-js-modal-window]',
    searchInput: '.search-modal__input',
    searchContainer: '.search-modal__wrap',
    headerContainer: '.header-nav--main'
  };

  var fadeOutClass = 'js-modal__hide-fade-out';
  var fadeInClass = 'js-modal__hide-fade-in';

  function preventDefault(fn) {
    return function(evt) {
      evt.preventDefault();
      return fn.call(this, evt);
    };
  }

  function openModalWindow(evt) {
    var $modal = $(selectors.modalWindow);
    $modal.addClass(fadeInClass);
    $modal.one('transitionend', function(){
      $(this).find(selectors.searchInput).focus();
      
      /* CF-60 search modal is hidden initally */
      $(this).attr('aria-hidden',false);
      slate.a11y.toggleHiddenFocus($modal, 'show');
      slate.a11y.toggleARIAHidden($modal, 'show');
      
    });

    $body.css('overflow', 'hidden');
  }

  function closeModalWindow(evt) {
    var $modal = $(selectors.modalWindow);
    $modal.removeClass(fadeInClass);
    $modal.one('transitionend', function(){
      $(this).find(selectors.searchInput).focus();
      
      /* CF-60 search modal is hidden again */
      $(this).attr('aria-hidden',true);
      slate.a11y.toggleHiddenFocus($modal, 'hide');
      slate.a11y.toggleARIAHidden($modal, 'hide');
      
    });
    $body.css('overflow', 'auto');
  }

  $document.on('keyup',function(evt) {
    if (evt.keyCode == 27) {
      closeModalWindow();
    }
  });

  $(selectors.closeModalLink).on("click", (function(){
    console.debug('~~ open search');
    preventDefault(closeModalWindow());
  }));

  $(selectors.openModalLink).on("click", (function(){
    console.debug('~~ open search');
    if( $(selectors.modalWindow).hasClass(fadeInClass)) {
      preventDefault(closeModalWindow());
    } else {
      preventDefault(openModalWindow());
    }
  }));

  $(selectors.headerContainer).on("click", (function(){
    if( $(selectors.modalWindow).hasClass(fadeInClass)) {
      preventDefault(closeModalWindow());
    }
  }));

}());

// Mobile Menu
theme.MobileMenu = (function($) {
    var selectors = {
      toggle: '[data-mobile-menu-toggle]',
      close: '[data-mobile-menu-close]',
      menu: '[data-mobile-menu]',
      submenu: '[data-mobile-submenu]',
      submenuTrigger: '[data-mobile-submenu-trigger]'
    };

    var classes = {
      open: 'is-open',
      bodyOpen: 'mobile-menu-open',
      overflowXHidden: 'overflow-x--hidden',
      subMenuClosed: 'is-closed',
      menuActiveLink: 'mobile-menu__primary-link-active'
    };

    function MobileMenu(container) {
      this.$container = $(container);

      this.name = 'mobileMenu';
      this.namespace = '.'+this.name;
      this.transitionDuration = slate.animations.getTransitionTimingDuration('slideout');

      $(selectors.toggle).on('click', this.onToggleClick.bind(this));
      $(selectors.close).on('click', this.onCloseClick.bind(this));
      $(selectors.submenuTrigger, this.$container).on('click', this.onSubmenuTriggerClick.bind(this));
    }

    MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {

      onCloseClick: function(e) {
        e.preventDefault();
        this.close();
      },

      onToggleClick: function(e) {
        e.preventDefault();
        this.toggle();
      },

      onSubmenuTriggerClick: function(e) {
        e.preventDefault();
        var $trigger = $(e.currentTarget);
        var $submenu = $trigger.siblings(selectors.submenu); // Trigger has to be sibling to the submenu element!

        $submenu.slideToggle({
          duration: this.transitionDuration,
          easing: 'easeOutQuint'
        });
        $trigger.toggleClass(classes.menuActiveLink);
      },

      toggle: function() {
        $(selectors.menu, this.$container).hasClass(classes.open) ? this.close() : this.open();
      },

      open: function() {
        $(document.body).addClass(classes.bodyOpen);
        $(document.documentElement).addClass(classes.overflowXHidden);
        $(selectors.menu, this.$container).addClass(classes.open);
        $(selectors.toggle).hide();
        $(selectors.close).show();
      },

      close: function() {
        $(document.body).removeClass(classes.bodyOpen);
        $(document.documentElement).removeClass(classes.overflowXHidden);
        $(selectors.menu, this.$container).removeClass(classes.open);
        $(selectors.toggle).show();
        $(selectors.close).hide();
      },

      /**
       * Theme Editor section events below
       */
      onSelect: function() {
        //console.log('['+this.name+'] - section:select');
        this.open();
      },

      onDeselect: function() {
        //console.log('['+this.name+'] - section:deselect');
        this.close();
      },

      onShow: function() {
        //console.log('['+this.name+'] - section:show');
      },

      onLoad: function() {
        //console.log('['+this.name+'] - section::load');
      },

      onUnload: function() {
        //console.log('['+this.name+'] - section::unload');
      }
    });

    return MobileMenu;
  })(jQuery);

slate.desktopNav = (function(){

  var $window = $(window);

  var selectors = {
    header: '#shopify-section-header',
    pencilBanner: '#shopify-section-pencil-banner',
    contentWindow: '#MainContent',
    mobileMenu: '.mobile-menu'
  }

  var navAnimationClass = 'is-fixed';
  var $header = $(selectors.header);
  var $pencilBanner = $(selectors.pencilBanner);
  var $contentWindow = $(selectors.contentWindow);
  var $mobileMenu = $(selectors.mobileMenu);

  function pencilStickyCheck() {
    var $headerHeight = $header.outerHeight();
    var $offset = $pencilBanner.outerHeight();

    if( $window.scrollTop() >  ( $offset ) ) {
      $header.addClass(navAnimationClass);
      //$contentWindow.css('margin-top', $headerHeight);
      $mobileMenu.css('top', $headerHeight);
    } else {
      $header.removeClass(navAnimationClass);
      //$contentWindow.css('margin-top', 0);
      $mobileMenu.css('top', $headerHeight + $offset);
    }
  }

  $window.on('scroll', $.throttle(50, requestAnimationFrame.bind(window, pencilStickyCheck)) ); 
  $window.ready( pencilStickyCheck ); 

})();

(function($) {

  var $window       = $(window);
  var $document     = $(document);
  var $body         = $(document.body);

  $(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('collection', theme.Collection);
    sections.register('pencil-banner', theme.PencilBanner);
    sections.register('subscription-modal', theme.SubscriptionModal);
    sections.register('instagram-feed', theme.InstagramFeed);   
    sections.register('slideshow', theme.Slideshow);
    sections.register('header', theme.Header);
    sections.register('mobile-menu', theme.MobileMenu);
    sections.register('footer', theme.Footer);
    sections.register('ajax-cart', theme.AjaxCart);
    sections.register('cart', theme.Cart);
    sections.register('related-products', theme.RelatedProducts);
    sections.register('subscription-slideup', theme.SubscriptionSlideUp);
    sections.register('press-blocks', theme.PressBlocks);
    sections.register('faqs', theme.FAQs);
    sections.register('four-up-mobile-slider', theme.FourUpMobileSlider);

    $('.in-page-link').on('click', function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
    
    $('.template-product .yotpo.yotpo a').on('click', function() {
       // console.log("test");
    });

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));
    // CF-60 initially hide all focusable elements
    slate.a11y.toggleHiddenFocus('data-slideshow-wrapper', 'hide');

    // Wrap RTE videos and tables to force responsive layout.
    slate.rte.fixTables();
    slate.rte.iframeReset();

    // Apply UA classes to the document
    slate.utils.userAgentBodyClass();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // Chosen JS plugin for select boxes
    slate.utils.chosenSelects();

    // Subscription forms submit handler

    var klaviyoSelectors = {
      klaviyoForm: 'form[data-klaviyo-list-id]',
      formContent: '[data-subscription-form-content]',
      formMessage: '[data-subscription-form-message]'
    } 

    var $klaviyoForm = $(klaviyoSelectors.klaviyoForm),
        $formContent = $(klaviyoSelectors.formContent),
        $formMessage = $(klaviyoSelectors.formMessage);

    var ajaxKlaviyoForm = new slate.AjaxKlaviyoForm($klaviyoForm, {
      listId: $klaviyoForm.data('klaviyo-list-id'),
      source: $klaviyoForm.data('klaviyo-source'),
      onSubscribeSuccess: onSubscribeSuccess,
      onSubmitFail: onSubmitFail
    });

    function onSubscribeSuccess() {
      $formMessage.html( $formMessage.data('message-success') );
      $formContent.addClass('show-message');
    };

    function onSubmitFail() {
      $formMessage.html( $formMessage.data('message-fail') );     
      $formContent.addClass('show-message');
    }

    $('body').on('click', '.load-more-button', function () {
      var urlToLoad = $(this).data('next-page');
      var selectorToFind = $(this).data('element-selector');
      var container = $($(this).data('wrapper-selector'));
      var useMasonry = !!(+$(this).data('use-masonry'));
      var loadMoreButton = $(this);
      var loadMoreButtonUrl = $(this).data('next-page');

      loadMoreButton.fadeOut('fast');

      $.get(urlToLoad)
        .done(function (data) {
          var htmlData = $(data);
          var newData = htmlData.find(selectorToFind);
          var newLoadMore = htmlData.find('.load-more-button');
          var newLoadMoreUrl = newLoadMore.data('next-page');
            container.append(newData);

          if (useMasonry) {
            container.masonry('appended', newData);
          }

          if (newLoadMore.length) {
            loadMoreButton
              .data('next-page', newLoadMore.data('next-page'))
              .fadeIn('fast');
          }

          if ($("[data-products-count]").length) {
            var actualItemCountText = $("[data-products-count]").text();
            var actualItemCount = parseInt(actualItemCountText);
            var totalItemCount = actualItemCount + newData.length;
            $("[data-products-count]").text(totalItemCount);
          }

          history.pushState('', 'Next page', urlToLoad);
        });
      });

  });

}(jQuery));

$(document).ready(function() {
  // This button will increment the value
  $('.template-product .qtyplus').click(function(e){
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name='+fieldName+']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".template-product .qtyminus").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $('input[name='+fieldName+']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(1);
    }
  });

  /* CF-60 - apply proper accessible visibility on hidden elements */
  slate.breakpoints.applyAccessibilityOnHidden($(window).width());
  
});
